import React, { useState, useEffect, useRef } from "react";
// import { jsPDF } from "jspdf";
import jsPDF from "jspdf";
import "./calculateEstimate.css";
import Swal from "sweetalert2";

import structure from "../image/structure.png";
import wall from "../image/wall.png";
import plaster from "../image/plaster.png";
import windowImg from "../image/window.png";
import door from "../image/door.png";
import kitchen from "../image/kitchen.png";
import bathroom from "../image/bathroom.png";
import electrical from "../image/electrical.png";
import paint from "../image/paint.png";
import staircase from "../image/staircase.png";
import flooring from "../image/flooring.png";
import plumbing from "../image/plumbing.png";
import height from "../image/height.png";
import waterproof from "../image/waterproof.png";
import finish from "../image/finish.png";
import pdfSection3Page1 from "../image/pdf-section-3-page-1.jpg";
import pdfSection3Page2 from "../image/pdf-section-3-page-2.jpg";
import pdfGreyStructureOnlySpecification from "../image/gray-structure-only-specification.jpg";
import pdfPmcSpecification from "../image/pmc-specification.jpg";
import pdfTermsGrayPmc from "../image/pdf-terms-gray-pmc.jpg";
import pdfArchitectureTerms from "../image/architecture-consultancy-service-4.0-terms-condition.jpg";
import pdfCompleteConstructionTerms from "../image/complete-construction-terms-condition.jpg";
import pdfPackageBasic from "../image/pdf-package-basic1.jpg";
import pdfPackageStandard from "../image/pdf-package-standard1.jpg";
import pdfPackagePremium from "../image/pdf-package-premium1.jpg";
import pdfRccSpecificationBasic from "../image/rcc-specification-basic.jpg";
import pdfRccSpecificationStandard from "../image/rcc-specification-standard.jpg";
import pdfRccSpecificationPremium from "../image/rcc-specification-premium.jpg";
import poppinsRegular from "../fonts/Poppins-Regular.ttf";
import poppinsSemiBold from "../fonts/Poppins-SemiBold.ttf";
import poppinsBold from "../fonts/Poppins-Bold.ttf";
import petitFormalScript from "../fonts/PetitFormalScript-Regular.ttf";


export default function CalculateEstimate() {
  
  
  const [step, setStep] = useState(1);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState("");
  const submitInFlightRef = useRef(false);

useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, [step]);

  const [showSummary, setShowSummary] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const getOrdinal = (num) => {
  if (num === 1) return "1st";

  if (num === 2) return "2nd";
  if (num === 3) return "3rd";
  return num + "th";
};

  const [data, setData] = useState({
    society: "",
    city: "",
    citySelection: "",
    plot: "",
    unit: "sq.ft",
    length: "",
    width: "",
    authority: "",
    road: "",

    area: 0,
    fsi: "",
    constructionArea: 0,

    architecture: "",
    pmc: false,
    liaison: "",
    construction: "",
    interior: "",
    execution: "",

    building: "",
    buildingType: "",
    customBuildingType: "",
    customCategory: "",
    customParking: "",
    customSubType: "",
    // floors logic
    floorsCount: "",
    floorsData: [],

    // p+3 inputs
    parking: "",
    cars: "",
    floor1: "",
    floor2: "",
    floor3: "",

    thirdFloorType: "",
thirdFloorFull: "",
thirdFloorRooms: "",
thirdFloorTerrace: "",
thirdFloorTerraceOnly: "",

secondFloorType: "",
secondFloorFull: "",
secondFloorRooms: "",
secondFloorTerrace: "",
secondFloorTerraceOnly: "",

    // custom building
    customRequirement: "",

    rooms: 2,

    other: "",

    name: "",
    mobile: "",
    email: "",

    // open plot fields
    openPlot: false,
    nonApprovedProperty: false,
    areaInputType: "", 
    openPlotLength: "",
    openPlotWidth: "",
    openPlotLengthWidthUnit: "sq.ft", 
    openPlotArea: "",
    openPlotAreaUnit: "sq.ft", 

packageType: "",



  });

  useEffect(() => {
  if (data.authority) {
    setData((prev) => ({
      ...prev,
      liaison: data.authority,
    }));
  }
}, [data.authority]);

//   const handle = (e) => {
//   const { name, value } = e.target;

//   if (name === "thirdFloorType") {
//     setData({
//       ...data,
//       thirdFloorType: value,
//       thirdFloorFull: "",
//       thirdFloorRooms: "",
//       thirdFloorTerrace: "",
//       thirdFloorTerraceOnly: "",
//     });
//   } else {
//     setData({ ...data, [name]: value });
//   }
// };

const clearFieldError = (...fieldNames) => {
  if (!fieldNames.length) return;

  setErrors((prev) => {
    const next = { ...prev };
    let changed = false;

    fieldNames.forEach((fieldName) => {
      if (fieldName in next) {
        delete next[fieldName];
        changed = true;
      }
    });

    return changed ? next : prev;
  });
};

const handle = (e) => {
  const { name, value, type, checked } = e.target;

  //  FIX: checkbox handling (PMC FIX)
  if (type === "checkbox") {
    setData({
      ...data,
      [name]: checked,
    });
    clearFieldError(name);
    return;
  }

  // CUSTOM PARKING FIX
  if (name === "customParking") {
    setData({
      ...data,
      customParking: value,
      cars: "",
      ground: ""
    });
    clearFieldError("customParking", "cars", "ground");
    return;
  }

  // THIRD FLOOR RESET
  if (name === "thirdFloorType") {
    setData({
      ...data,
      thirdFloorType: value,
      thirdFloorFull: "",
      thirdFloorRooms: "",
      thirdFloorTerrace: "",
      thirdFloorTerraceOnly: "",
    });
    clearFieldError("thirdFloorType", "thirdFloorFull", "thirdFloorRooms", "thirdFloorTerraceOnly");
    return;
  }

  if (name === "construction") {
    setData({
      ...data,
      construction: value,
      packageType: value === "complete" ? data.packageType : "",
    });
    clearFieldError("construction", "packageType");
    return;
  }

  if (name === "citySelection") {
    setData({
      ...data,
      citySelection: value,
      city: value === "Other" ? "" : value,
    });
    clearFieldError("citySelection", "city");
    return;
  }

  // DEFAULT
  setData({ ...data, [name]: value });
  clearFieldError(name);
};


 useEffect(() => {
  const savedData = JSON.parse(localStorage.getItem("estimateData"));

  if (savedData) {
    setData((prev) => ({
      ...prev,
      ...savedData,
      citySelection:
        savedData.citySelection ||
        (["Pune", "Nashik", "Latur", "Sambhaji Nagar", "Other"].includes(savedData.city)
          ? savedData.city
          : savedData.city
            ? "Other"
            : ""),
    }));

  
    if (savedData.openPlot) {
      setStep(3);   // Open Plot → Step 3
    } else {
      setStep(2);   // NA Layout → Step 2
    }

    localStorage.removeItem("estimateData");
  }
}, []);

  // Handle window resize for mobile detection
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // iOS Safari can zoom aggressively on form interactions; keep the viewport stable on this page only.
    const isIOSDevice =
      /iPad|iPhone|iPod/.test(window.navigator.userAgent) ||
      (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);

    if (!isIOSDevice) return;

    const viewportMeta = document.querySelector('meta[name="viewport"]');
    if (!viewportMeta) return;

    const originalViewportContent = viewportMeta.getAttribute("content") || "";
    viewportMeta.setAttribute(
      "content",
      "width=device-width, initial-scale=1.0, maximum-scale=1.0, viewport-fit=cover"
    );

    return () => {
      viewportMeta.setAttribute("content", originalViewportContent);
    };
  }, []);

  const handleFloors = (e) => {
    const count = parseInt(e.target.value) || 0;

    let floorsArray = [];

    for (let i = 1; i <= count; i++) {
      floorsArray.push({ value: "" });
    }

    setData((prev) => ({
      ...prev,
      floorsCount: count,
      floorsData: floorsArray,
    }));
  };

  const handleFloorInput = (index, value) => {
    let updated = [...data.floorsData];

    updated[index].value = value;

    setData((prev) => ({
      ...prev,
      floorsData: updated,
    }));
  };

useEffect(() => {

let area = 0;

/* Length Width calculation */

if(data.areaInputType==="lengthWidth"){

// let l=parseFloat(data.length)
// let w=parseFloat(data.width)

let l = parseFloat(data.openPlot ? data.openPlotLength : data.length);
let w = parseFloat(data.openPlot ? data.openPlotWidth : data.width);

if(!l || !w) return

area = l * w

// if(data.unit==="Meters"){
let unit = data.openPlot ? data.openPlotLengthWidthUnit : data.unit;

if(unit === "Meters" || unit === "Meter"){

area = area * 10.7639
}

}

/* Total Area calculation */

if(data.areaInputType==="area"){

let a=parseFloat(data.openPlotArea)

if(!a) return

area = a

if(data.openPlotAreaUnit==="sq.meter"){
area = area * 10.7639
}

}

    let fsi = 0;

    // PMC + PCMC
    if (data.authority === "PMC" || data.authority === "PCMC") {
      if (data.road === "6") fsi = 1.1;
      else if (data.road === "9") fsi = 1.7;
      else if (data.road === "12") fsi = 2.0;
      else if (data.road === "15") fsi = 2.1;
      else if (data.road === "24") fsi = 2.3;
      else if (data.road === "30") fsi = 2.5;
    }

    // PMRDA
    if (data.authority === "PMRDA") {
      if (data.road === "6") fsi = 1.0;
      else if (data.road === "9") fsi = 1.4;
      else if (data.road === "12") fsi = 1.5;
      else if (data.road === "15") fsi = 1.7;
      else if (data.road === "24") fsi = 1.9;
      else if (data.road === "30") fsi = 2.0;
    }

    // Construction Area
    let constructionArea = area * fsi;

    // setData((prev) => ({
    //   ...prev,
    //   area: area.toFixed(2),
    //   fsi: fsi,
    //   constructionArea: constructionArea.toFixed(2),
    // }));

    setData((prev) => {
  const newArea = area.toFixed(2);
  const newConstruction = constructionArea.toFixed(2);

  if (
    prev.area === newArea &&
    prev.fsi === fsi &&
    prev.constructionArea === newConstruction
  ) {
    return prev;
  }

  return {
    ...prev,
    area: newArea,
    fsi: fsi,
    constructionArea: newConstruction,
  };
});

}, [
  data.length,
  data.width,
  data.unit,
  data.road,
  data.authority,
  data.areaInputType,
  data.openPlotArea,
  data.openPlotAreaUnit,
  data.openPlot,
  data.openPlotLength,
  data.openPlotWidth,
  data.openPlotLengthWidthUnit
]);


// ========================================
// PRICE CONFIGURATION
// ========================================
const priceConfig = {
  grey: {
    TwinBungalow: {
      percentage: { plinth: 0.52, parking: 0.60, floor1: 0.60, floor2: 0.40, floor3: 0.30 },
      addon: 0.55
    },
    IndependentBungalow: {
      percentage: { plinth: 0.50, parking: 0.55, floor1: 0.55, floor2: 0.40, floor3: 0.28 },
      addon: 0.55
    },
    RowHouse: {
      percentage: { plinth: 0.55, parking: 0.60, floor1: 0.60, floor2: 0.40, floor3: 0.30 },
      addon: 0.60
    },
    ResidentialApartment: {
      percentage: { plinth: 0.50, parking: 0.60, floor1: 0.60, floor2: 0.60, floor3: 0.60 },
      addon: 0.60
    },
    StudioApartment: {
       percentage: { plinth: 0.50, parking: 0.60, floor1: 0.60, floor2: 0.60, floor3: 0.60 },
      addon: 0.60
    },
    Commercial: {
      percentage: { plinth: 0.50, parking: 0.60, floor1: 0.60, floor2: 0.60, floor3: 0.60 },
      addon: 0.60
    },
    MixedUse: {
      percentage: { plinth: 0.50, parking: 0.60, floor1: 0.60, floor2: 0.60, floor3: 0.60 },
      addon: 0.60
    }
  },
  complete: {
    TwinBungalow: {
      percentage: { plinth: 0.52, parking: 0.60, floor1: 0.55, floor2: 0.40, floor3: 0.28 },
      addon: 0.55
    },
    IndependentBungalow: {
      percentage: { plinth: 0.50, parking: 0.55, floor1: 0.55, floor2: 0.40, floor3: 0.28 },
      addon: 0.55
    },
    RowHouse: {
      percentage: { plinth: 0.55, parking: 0.60, floor1: 0.60, floor2: 0.40, floor3: 0.30 },
      addon: 0.60
    },
    ResidentialApartment: {
       percentage: { plinth: 0.50, parking: 0.60, floor1: 0.60, floor2: 0.60, floor3: 0.60 },
      addon: 0.60
    },
    StudioApartment: {
      percentage: { plinth: 0.50, parking: 0.60, floor1: 0.60, floor2: 0.60, floor3: 0.60 },
      addon: 0.60
    },
    Commercial: {
      percentage: { plinth: 0.50, parking: 0.60, floor1: 0.60, floor2: 0.60, floor3: 0.60 },
      addon: 0.60
    },
    MixedUse: {
      percentage: { plinth: 0.50, parking: 0.60, floor1: 0.60, floor2: 0.60, floor3: 0.60 },
      addon: 0.60
    }
  }
};

const rateConfig = {
  grey: { plinth: 900, parking: 900, floor: 1100, terrace: 1100 },
  complete: { plinth: 900, parking: 900, floor: 1800, terrace: 1800 },
   pmc: {plinth: 900, parking: 900, floor: 1800,terrace: 1800}
};

const COMPLETE_PACKAGE_RATE_CONFIG = {
  basic: { plinth: 800, parking: 800, floor: 1600, terrace: 1600 },
  standard: { plinth: 900, parking: 900, floor: 1800, terrace: 1800 },
  premium: { plinth: 900, parking: 900, floor: 2000, terrace: 2000 }
};

const BUILDING_LABELS = {
  TwinBungalow: "Twin Bungalow",
  IndependentBungalow: "Independent Bungalow",
  RowHouse: "Row House",
  ResidentialApartment: "Residential Apartment",
  StudioApartment: "Studio Apartment",
  Commercial: "Commercial",
  MixedUse: "Mixed Use"
};

const STRUCTURE_LABELS = {
  p3: "Parking + 3 Floors",
  g2: "Ground + 2 Floors",
  custom: "Custom Building"
};

const PACKAGE_LABELS = {
  basic: "Basic",
  standard: "Standard",
  premium: "Premium"
};

const CITY_OPTIONS = ["Pune", "Nashik", "Latur", "Sambhaji Nagar", "Other"]; 

const normalizeBuildingTypeValue = (buildingType) => {
  const aliases = {
    "Twin Bungalow": "TwinBungalow",
    "Independent Bungalow": "IndependentBungalow",
    "Row House": "RowHouse",
    "Residential Apartment": "ResidentialApartment",
    ResidentalApartment: "ResidentialApartment",
  };

  return aliases[buildingType] || buildingType;
};

const requiresPackageSelection = (constructionValue) => constructionValue === "complete";

const getContactStepBackTarget = (constructionValue) =>
  requiresPackageSelection(constructionValue) ? 6 : 5;

const PAYMENT_MILESTONES = [
  { label: "Advance Payment", percent: 10 },
  { label: "Plinth Work Completion", percent: 20 },
  { label: "First Slab Completion", percent: 20 },
  { label: "Second Slab Completion", percent: 20 },
  { label: "Brick Work Completion", percent: 20 },
  { label: "Plaster Work Completion", percent: 10 }
];

const NO_CONSTRUCTION_PAYMENT_MILESTONES = [
  { label: "Advance", percent: 25 },
  { label: "After Design Finalised", percent: 25 },
  { label: "After Liasoning File Process", percent: 25 },
  { label: "After Detail Working Drawings", percent: 25 }
];

const getDisplayBuildingType = (buildingType) =>
  BUILDING_LABELS[normalizeBuildingTypeValue(buildingType)] || buildingType || "-";

const getDisplayStructure = (building) =>
  STRUCTURE_LABELS[building] || building || "-";

const getDisplayConstructionType = (data) => {
  if (data.construction === "grey") return "Grey Structure Only";
  if (data.construction === "complete") return "Complete Construction";
  if (data.construction === "pmc") return "PMC (Project Management Consultancy)";
  if (data.construction === "none") return "No Construction Services Required";
  return "-";
};

const getProjectAddress = (data) => {
  const parts = [data.society?.trim(), data.city?.trim()].filter(Boolean);
  return parts.length ? parts.join(", ") : "-";
};

const getDiscountDetails = (data) => {
  const societyName = data.society?.trim();
  const hasConstructionService = ["grey", "complete", "pmc"].includes(data.construction);

  if (data.construction === "none" && data.architecture) {
    return {
      amount: 25000,
      label: "Architecture Discount"
    };
  }

  if (hasConstructionService && (data.openPlot || (data.nonApprovedProperty && societyName))) {
    return {
      amount: 50000,
      label: data.openPlot
        ? societyName ? `${societyName} Open Plot Discount` : "Open Plot Discount"
        : `${societyName} Layout Discount`
    };
  }

  return {
    amount: 0,
    label: "Project Discount"
  };
};

const formatCurrency = (value, decimals = 0) =>
  Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

const amountToWords = (input) => {
  const num = Math.round(Number(input || 0));
  if (!num) return "Zero Only";

  const ones = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen"
  ];
  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  const belowThousand = (n) => {
    let parts = [];

    if (n >= 100) {
      parts.push(`${ones[Math.floor(n / 100)]} Hundred`);
      n %= 100;
    }

    if (n >= 20) {
      parts.push(`${tens[Math.floor(n / 10)]}${n % 10 ? ` ${ones[n % 10]}` : ""}`);
    } else if (n > 0) {
      parts.push(ones[n]);
    }

    return parts.join(" ").trim();
  };

  const parts = [];
  let remaining = num;

  const crore = Math.floor(remaining / 10000000);
  if (crore) {
    parts.push(`${belowThousand(crore)} Crore`);
    remaining %= 10000000;
  }

  const lakh = Math.floor(remaining / 100000);
  if (lakh) {
    parts.push(`${belowThousand(lakh)} Lakh`);
    remaining %= 100000;
  }

  const thousand = Math.floor(remaining / 1000);
  if (thousand) {
    parts.push(`${belowThousand(thousand)} Thousand`);
    remaining %= 1000;
  }

  if (remaining) {
    parts.push(belowThousand(remaining));
  }

  return `${parts.join(" ").trim()} Only`;
};

// ========================================
// STATIC CONTENT DATA
// ========================================
const staticContent = {
  scopeOfServices: {
    heading: "3.0 DETAILED SCOPE OF SERVICES & SCHEDULES",
    
    architecturalDesign: {
      subheading: "3.1 Architectural Design & Drawings",
      studyAnalysis: [
        "Client requirements & internal activity",
        "Climate, Site Topography & Conditions"
      ],
      designPhase: [
        "Concept Design & Presentation Drawings",
        "Façade Design & 3D Views",
        "Compound wall design"
      ],
      siteLayout: [
        "Future expansion & Road Networking",
        "Paved areas & Site Plan preparation",
        "UG tank, Septic tank & Drainage positions",
        "Plinth layout service coordinated plan"
      ]
    },

    workingDrawings: {
      subheading: "3.2 Working Drawings / Execution (WD-50 & WD-100)",
      technicalDrawings: [
        "Setting Out & Centre line plans",
        "RCC, Structural Steel & Allied Infrastructure",
        "Dimensional Floor plans, Elevations & Sections",
        "Positioning for UG tank & Septic tank"
      ],
      detailingServices: [
        "Staircase & Toilet detail drawings",
        "Compound wall, Main Gate & Fabrication details",
        "Door & Window schedules with specifications",
        "Complete Electrical & Plumbing layouts"
      ]
    }
  },

  civilFinishing: {
    heading: "4.0 LIST OF CIVIL FINISHING ITEMS FOR INTERIOR WORK",
    items: [
      {
        sr: 1,
        description: "Providing and fixing main door (1.05m x 2.10m) in Teak Wood (Sagwan) frame with decorative flush door, including Godrej lock, fittings, labour, etc. complete.",
        qty: "1 Nos"
      },
      {
        sr: 2,
        description: "Providing and fixing internal flush doors (0.90m x 2.10m, 0.90m x 2.10m, 0.75m x 2.10m) as per design.",
        qty: "5 Nos"
      },
      {
        sr: 3,
        description: "Providing and fixing kitchen platform up to 10 ft length and 2 ft width, including kitchen dado up to 3'-0\" height (approx. 30 sq.ft).",
        qty: "1 Job"
      },
      {
        sr: 4,
        description: "Providing and fixing toilet flush doors (0.75m x 2.10m) and window (0.60m x 0.75m) as per design.",
        qty: "As per design"
      },
      {
        sr: 5,
        description: "Providing and fixing 20 mm thick limestone flooring with standard fittings, including labour, etc. complete.",
        qty: "As per design"
      },
      {
        sr: 6,
        description: "Providing and fixing toilet wall tiles (2' x 1') up to Rs.50/sq.ft, including standard fittings and labour.",
        qty: "As required"
      },
      {
        sr: 7,
        description: "Providing and fixing toilet floor tiles (1' x 1') up to Rs.50/sq.ft, including standard fittings and labour.",
        qty: "As required"
      },
      {
        sr: 8,
        description: "Providing and fixing door frames (1.05m x 2.10m, 0.90m x 2.10m, 0.75m x 2.10m) in green marble or steel grey granite.",
        qty: "As per design"
      },
      {
        sr: 9,
        description: "Providing and applying three coats of paint for internal and external walls (Asian Apex for external, oil bound distemper for internal).",
        qty: "As per design"
      },
      {
        sr: 10,
        description: "Electrical work (concealed fitting) using Legrand switches and Polycab wires, with 5 points per room.",
        qty: "As per design"
      },
      {
        sr: 11,
        description: "Providing toilet fittings including commode, wash basin, shower, diverter with UPVC pipes and sanitary fittings. (Commode up to ₹6000, concealed flush tank up to ₹3500, wash basin up to ₹1500; Jaguar basic taps, mixer, Finolex pipes or equivalent).",
        qty: "4 Basins, 4 Commodes"
      },
      {
        sr: 12,
        description: "Providing and fixing aluminum sliding powder-coated windows (2 or 3 track).",
        qty: "As per design"
      },
      {
        sr: 13,
        description: "Electrical points: 5 points per room, including 10 Nos. 5 AMP switches and 5 Nos. 15 AMP switches, concealed wiring with Polycab wires and Legrand switches/boards.",
        qty: "As per design"
      }
    ]
  },

  specifications: {
    heading: "5.0 SPECIFICATIONS FOR CONSTRUCTION",
    rccWork: {
      subheading: "5.1 R.C.C WORK and finishing items",
      items: [
        "R.C.C framed structure in M-20 & F-500 Grade as per design provided by owner Architect & R.C.C designer.",
        "Excavation for footing up to hard Strata shall be upto 1.5 m depth (more than 1.5 m below shall be charged extra) If hard strata to be removed by breaker for footing & underground water tank, septic tank, charges shall be charged extra.",
        "Steel as per the Drawing Ground + 2 (TMT Bars top brands)",
        "P.C.C 1:4:8 – 100 mm Thick for footing & plinth.",
        "R.C.C footing, plinth beam as per design.",
        "Murrum filling and Rubble soling for plinth and 230 mm thick brick wall for plinth, plinth height 450 mm or 600 mm above ground level.",
        "R.C.C Column, Floor Slab, Staircase, Chajja, Staircase Pardi, Lintels, Lofts as per drawings.",
        "Slab height shall be considered 3.00 M from Slab Top to Slab Top.",
        "Cement 53/43 Grade (Birla Super or Dalmiya or equivalent).",
        "Slab & R.C.C Work (Sand + Crush + Aggregate).",
        "Internal Gypsum (POP) plaster 10 mm Thickness.",
        "External Plaster double coat M Sand Plaster.",
        "Outer Brick wall – 6\" thick and inner brick wall – 6\" thick Red Brick.",
        "Construction of walls in Natural Brick (red brick).",
        "Slab top at 3.05 M (10'0\").",
        "Staircase – Granite up to 100 / sq.ft.",
        "Staircase railing MS pipe – 1.75.",
        "Window sill in Granite or equivalent composite marble for all windows Granite up to 100 / sqft"
      ]
    }
  },

  termsConditions: {
    heading: "7.0 TERMS, CONDITIONS & EXCLUSIONS",
    sections: {
      siteOwner: {
        title: "1. Site & Owner Responsibilities",
        items: [
          "Provision of electricity and water for construction shall be arranged by the Owner.",
          "Open space for labour accommodation and material stacking shall be arranged by the Owner.",
          "Cost of drilling machine for excavation, if required, shall be borne by the Owner.",
          "Required documents (Demarcation Copy, 7/12 Extract, etc.) shall be provided by the Client."
        ]
      },
      executionBilling: {
        title: "2. Execution & Billing",
        items: [
          "All specifications, drawings, measurements, and instructions of the Architect and Structural Designer shall be followed by the Contractor.",
          "Final billing shall be based on actual site measurements."
        ]
      },
      feesValidity: {
        title: "3. Fees & Validity",
        items: [
          "Fees are valid for 12 months from the date of Agreement.",
          "In case of increase in steel rates or other material costs, the additional amount shall be borne by the Client."
        ]
      },
      exclusions: {
        title: "4. Exclusions",
        items: [
          "Structural, MEP, Electrical, Irrigation, Water Supply, and other consultant charges.",
          "Proof checking.",
          "Valuation reports for loans or other purposes.",
          "Obtaining plans, documents, certificates, or approvals from authorities.",
          "Any item not specifically mentioned in the scope of work."
        ]
      },
      taxesCharges: {
        title: "5. Taxes & Government Charges",
        items: [
          "Fees are exclusive of GST and other applicable Government Taxes.",
          "PMRDA challans and other statutory charges shall be borne by the Client."
        ]
      }
    }
  }
};

// ========================================
// CALCULATE ESTIMATE
// ========================================
const calculateEstimate = (data) => {
  const baseArea = parseFloat(data.area);
  if (!baseArea) return null;

  const buildingType = normalizeBuildingTypeValue(data.buildingType);
  const constructionKey = data.construction === "grey" ? "grey" : "complete";
  const config = priceConfig[constructionKey][buildingType];

  if (!config) {
    console.error("Invalid building type:", data.buildingType);
    return null;
  }

  // const rates = data.construction === "complete"
  //   ? COMPLETE_PACKAGE_RATE_CONFIG[data.packageType] || rateConfig.complete
  //   : rateConfig.grey;

const rates =
  data.construction === "complete"
    ? COMPLETE_PACKAGE_RATE_CONFIG[data.packageType] || rateConfig.complete
    : data.construction === "grey"
      ? rateConfig.grey
      : rateConfig.complete;

  const standardFloorPercent = config.percentage.floor1;
  const terraceMixPercent = config.percentage.floor3;
  const rows = [];

  const pushRow = (label, percent, type = "floor") => {
    if (!percent) return;

    let rate = rates.floor;

    if (type === "plinth") rate = rates.plinth;
    if (type === "parking") rate = rates.parking;
    if (type === "terrace") rate = rates.terrace;

    const area = baseArea * percent;

    if (type === "addon") rate = 900;

    rows.push({
      label,
      percent,
      type,
      area,
      rate,
      baseRate: type === "addon" ? 900 : rate,
      packageRate: 0,
      cost: area * rate,
    });
  };

  const resolveTopFloor = (
    floorType,
    fullLabel,
    mixedLabel,
    terraceLabel,
    fullFloorPercent = standardFloorPercent
  ) => {
    if (floorType === "full") {
      pushRow(fullLabel, fullFloorPercent, "floor");
      return;
    }

    if (floorType === "half") {
      pushRow(mixedLabel, terraceMixPercent, "terrace");
      return;
    }

    if (floorType === "terrace") {
      pushRow(terraceLabel, terraceMixPercent, "terrace");
      return;
    }

    pushRow(mixedLabel, terraceMixPercent, "terrace");
  };

  pushRow("Plinth Work", config.percentage.plinth, "plinth");

  if (data.building === "p3") {
    pushRow("Parking / Stilt", config.percentage.parking, "parking");
    pushRow("First Floor", config.percentage.floor1, "floor");
    pushRow("Second Floor", config.percentage.floor2, "floor");
    resolveTopFloor(
      data.thirdFloorType,
      "Third Floor",
      "Third Floor (Room + Terrace)",
      "Terrace Floor"
    );
  } else if (data.building === "g2") {
    pushRow("Ground Floor", config.percentage.floor1, "floor");
    pushRow("First Floor", config.percentage.floor1, "floor");
    resolveTopFloor(
      data.secondFloorType,
      "Second Floor",
      "Second Floor (Room + Terrace)",
      "Terrace Floor",
      config.percentage.floor2
    );
  } else if (data.building === "custom") {
    if (data.customParking === "yes") {
      pushRow("Parking / Stilt", config.percentage.parking, "parking");
    } else {
      pushRow("Ground Floor", config.percentage.floor1, "floor");
    }

    data.floorsData.forEach((_, index) => {
      const floorNumber = index + 1;
      const isLast = floorNumber === data.floorsData.length;

      if (!isLast) {
        pushRow(`${getOrdinal(floorNumber)} Floor`, standardFloorPercent, "floor");
        return;
      }

      resolveTopFloor(
        data[`floor${floorNumber}Type`],
        `${getOrdinal(floorNumber)} Floor`,
        `${getOrdinal(floorNumber)} Floor (Room + Terrace)`,
        `${getOrdinal(floorNumber)} Floor Terrace`
      );
    });
  } else {
    pushRow("Parking / Stilt", config.percentage.parking, "parking");
    pushRow("First Floor", config.percentage.floor1, "floor");
    pushRow("Second Floor", config.percentage.floor2, "floor");
    pushRow("Third Floor (Room + Terrace)", terraceMixPercent, "terrace");
  }

  pushRow(
    "Parapet Wall + Terrace Waterproofing + Staircase Head Room + Water Tank",
    config.addon,
    "addon"
  );

  const final = rows;
  const constructionTotal = final.reduce((sum, r) => sum + r.cost, 0);

  const pmcFee = data.construction === "pmc" ? constructionTotal * 0.10 : 0;
  const architectureFee = data.architecture ? constructionTotal * 0.04 : 0;
  const liaisonFee = data.pmc ? 150000 : 0;
  const discountMeta = getDiscountDetails(data);
  const grossConsultancyFee = architectureFee + pmcFee + liaisonFee;
  const discount = discountMeta.amount;
  const finalConsultancyFee = grossConsultancyFee - discount;

  const finalTotal =
    data.construction === "none"
      ? finalConsultancyFee
      : constructionTotal + finalConsultancyFee;

  return {
    final,
    constructionTotal,
    architectureFee,
    pmcFee,
    liaisonFee,
    grossConsultancyFee,
    discount,
    discountLabel: discountMeta.label,
    finalConsultancyFee,
    selectedPackageRate: rates.floor,
    selectedPackageName: data.construction === "complete" && data.packageType
      ? PACKAGE_LABELS[data.packageType]
      : "",
    finalTotal,
  };
};

// ========================================
// COMPLETE PDF WITH STATIC + DYNAMIC
// ========================================


const imageAssetToDataUrl = async (src) => {
  const response = await fetch(src);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

const assetToBase64 = async (src) => {
  const response = await fetch(src);
  const buffer = await response.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  let binary = "";
  const chunkSize = 0x8000;

  for (let index = 0; index < bytes.length; index += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(index, index + chunkSize));
  }

  return btoa(binary);
};

const registerQuotationFonts = async (doc) => {
  const [regular, semiBold, bold, script] = await Promise.all([
    assetToBase64(poppinsRegular),
    assetToBase64(poppinsSemiBold),
    assetToBase64(poppinsBold),
    assetToBase64(petitFormalScript)
  ]);

  doc.addFileToVFS("Poppins-Regular.ttf", regular);
  doc.addFont("Poppins-Regular.ttf", "Poppins", "normal");
  doc.addFileToVFS("Poppins-SemiBold.ttf", semiBold);
  doc.addFont("Poppins-SemiBold.ttf", "Poppins", "semibold");
  doc.addFileToVFS("Poppins-Bold.ttf", bold);
  doc.addFont("Poppins-Bold.ttf", "Poppins", "bold");
  doc.addFileToVFS("PetitFormalScript-Regular.ttf", script);
  doc.addFont("PetitFormalScript-Regular.ttf", "PetitFormalScript", "normal");
};

const getNextQuotationRef = () => {
  const year = new Date().getFullYear();
  const key = `dwelloraQuotationSequence:${year}`;
  const current = Number(window.localStorage?.getItem(key) || 0);
  const next = Number.isFinite(current) ? current + 1 : 1;

  window.localStorage?.setItem(key, String(next));

  return `DH/${year}/${String(next).padStart(2, "0")}`;
};

const waitForNextPaint = () =>
  new Promise((resolve) => {
    if (typeof window === "undefined" || typeof window.requestAnimationFrame !== "function") {
      setTimeout(resolve, 0);
      return;
    }

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(resolve);
    });
  });

const getSubmitStatusMessage = (status) => {
  const statusMap = {
    "Generating PDF...": "Your quotation PDF is being prepared.",
    "Saving your details...": "We are saving your project details securely.",
    "Uploading PDF...": "Your PDF is being uploaded so it can be shared on WhatsApp.",
    "Opening WhatsApp...": "Almost done. Your WhatsApp PDF share is getting ready.",
  };

  return (
    statusMap[status] ||
    "Please wait while we prepare your quotation PDF and WhatsApp share."
  );
};

const generatePerfectPDF = async (data, estimate) => {
  if (!estimate || !estimate.final?.length) {
    alert("Unable to generate quotation. Estimate calculation is missing.");
    return;
  }

  const [
    section3Page1Image,
    section3Page2Image,
    greyStructureOnlySpecificationImage,
    pmcSpecificationImage,
    termsGrayPmcImage,
    architectureTermsImage,
    completeConstructionTermsImage,
    packageBasicImage,
    packageStandardImage,
    packagePremiumImage,
    rccSpecificationBasicImage,
    rccSpecificationStandardImage,
    rccSpecificationPremiumImage
  ] = await Promise.all([
    imageAssetToDataUrl(pdfSection3Page1),
    imageAssetToDataUrl(pdfSection3Page2),
    imageAssetToDataUrl(pdfGreyStructureOnlySpecification),
    imageAssetToDataUrl(pdfPmcSpecification),
    imageAssetToDataUrl(pdfTermsGrayPmc),
    imageAssetToDataUrl(pdfArchitectureTerms),
    imageAssetToDataUrl(pdfCompleteConstructionTerms),
    imageAssetToDataUrl(pdfPackageBasic),
    imageAssetToDataUrl(pdfPackageStandard),
    imageAssetToDataUrl(pdfPackagePremium),
    imageAssetToDataUrl(pdfRccSpecificationBasic),
    imageAssetToDataUrl(pdfRccSpecificationStandard),
    imageAssetToDataUrl(pdfRccSpecificationPremium)
  ]);

  const packageImages = {
    basic: packageBasicImage,
    standard: packageStandardImage,
    premium: packagePremiumImage
  };
  const packageSpecificationImages = {
    basic: rccSpecificationBasicImage,
    standard: rccSpecificationStandardImage,
    premium: rccSpecificationPremiumImage
  };
  const quotationRef = getNextQuotationRef();

  const doc = new jsPDF({ unit: "mm", format: "a4" });
  await registerQuotationFonts(doc);
  const PAGE = { w: 210, h: 297, margin: 14 };

  const COLORS = {
    primary: [142, 88, 168], 
    // tableHeader: [81, 46, 102], 
    tableHeader: [142, 88, 168],
    accent: [115, 78, 137],
    soft: [242, 235, 245],
    softAccent: [241, 233, 247],
    border: [220, 214, 227],
    text: [45, 55, 72], // Dark slate
    label: [74, 85, 104], // Muted dark blue
    muted: [100, 110, 120],
    danger: [184, 33, 54],
    success: [34, 139, 34]
  };

const FONT = {
  title: 22,
  section: 14,
  subSection: 11,
  body: 9.5,
  small: 8.5,
  footer: 8,
  tableHeader: 9.5
};

  const LAYOUT = {
    sectionHeight: 9,
    lineHeight: 5,
    smallLineHeight: 4.5,
    infoGap: 7,
    infoLabelWidth: 32,
    infoColumnGap: 12,
    footerReserve: 40
  };

  let y = 0;
  let pageNum = 1;
  const isCompleteConstruction = data.construction === "complete";
  const isGreyStructure = data.construction === "grey";
  const isPMCConstruction = data.construction === "pmc";
  const isNoConstructionService = data.construction === "none";
  const setText = (size, style = "normal", color = COLORS.text) => {
    if (style === "script") {
      doc.setFont("PetitFormalScript", "normal");
    } else {
      const fontStyle = ["normal", "semibold", "bold"].includes(style) ? style : "normal";
      doc.setFont("Poppins", fontStyle);
    }
    doc.setFontSize(size);
    doc.setTextColor(...color);
  };

  const startPage = (isFirstPage = false) => {
    y = PAGE.margin;
 
    if (isFirstPage) {
      doc.setFillColor(...COLORS.primary);
      doc.rect(0, 0, PAGE.w, 45, "F");

      // setText(24, "bold", [255, 255, 255]);
      setText(FONT.title, "bold", [255, 255, 255]);
      doc.text("DWELLORA HOMES", PAGE.margin, 22);

      setText(FONT.small, "italic", [220, 200, 230]);
      doc.text("A Venture by Dwellora Designs LLP", PAGE.margin, 29);

      // setText(14, "bold", [255, 255, 255]);
      setText(FONT.section, "bold", [255, 255, 255]);
      doc.text("QUOTATION", PAGE.w - PAGE.margin, 20, { align: "right" });

      // setText(9, "normal", [255, 255, 255]);
      setText(FONT.small, "normal", [255, 255, 255]);
      doc.text(`Ref: ${quotationRef}`, PAGE.w - PAGE.margin, 27, { align: "right" });
      doc.text(`Date: ${new Date().toLocaleDateString("en-GB").replace(/\//g, '.')}`, PAGE.w - PAGE.margin, 33, { align: "right" });

      y = 55;
    } else {
      y = 20;
    }
  };

  const ensureSpace = (needed) => {
    if (y + needed <= PAGE.h - PAGE.margin - (pageNum > 1 ? 15 : 15)) {
      return;
    }
    doc.addPage();
    pageNum++;
    startPage(false);
  };

  const nextPage = () => {
    doc.addPage();
    pageNum++;
    startPage(false);
  };

  const estimateBulletHeight = (items, indent = PAGE.margin + 3) =>
    items.reduce((total, item) => {
      const lines = doc.splitTextToSize(`- ${item}`, PAGE.w - indent - PAGE.margin);
      return total + lines.length * LAYOUT.lineHeight + 1;
    }, 0);

  const startFlowSection = (title, minContentHeight = 16, options = {}) => {
    const neededHeight = 10 + minContentHeight;

    if (options.forceNewPage || y + neededHeight > PAGE.h - PAGE.margin) {
      nextPage();
    }

    drawSection(title);
  };

  const drawSection = (title) => {
    ensureSpace(16);
    doc.setFillColor(248, 250, 252); // Light gray-blue
    doc.rect(PAGE.margin, y, PAGE.w - PAGE.margin * 2, 12, "F");
    
    doc.setFillColor(33, 33, 33);
    doc.rect(PAGE.margin + 2, y + 2.5, 1.2, 7, "F");
    
    // setText(12, "bold", [50, 60, 70]); // Dark slate

    setText(FONT.section, "bold", [50, 60, 70]);
    doc.text(title, PAGE.margin + 6, y + 8);
    y += 18;
  };

  const drawInfoGrid = (items) => {
    const colWidth = (PAGE.w - PAGE.margin * 2 - LAYOUT.infoColumnGap) / 2;
    const leftX = PAGE.margin;
    const rightX = PAGE.margin + colWidth + LAYOUT.infoColumnGap;
    const rows = [];

    for (let index = 0; index < items.length; index += 2) {
      rows.push(items.slice(index, index + 2));
    }

    rows.forEach((row) => {
      const rowHeight = Math.max(
        ...row.map((item) => {
          const valueLines = doc.splitTextToSize(item.value || "-", colWidth - LAYOUT.infoLabelWidth - 2);
          return Math.max(10, Math.max(1, valueLines.length) * LAYOUT.lineHeight + 2);
        })
      );

      ensureSpace(rowHeight + 2);

      row.forEach((item, cellIndex) => {
        const x = cellIndex === 0 ? leftX : rightX;
        const valueX = x + LAYOUT.infoLabelWidth;

        setText(9.5, "bold", COLORS.label);
        doc.text(item.label, x, y + 4);

        setText(10, "normal", COLORS.text);
        const split = doc.splitTextToSize(item.value || "-", colWidth - LAYOUT.infoLabelWidth - 2);
        doc.text(split, valueX, y + 4);
      });

      y += rowHeight;
    });
  };

  const drawAmountRow = (label, amount, options = {}) => {
    ensureSpace(8);
    setText(options.bold ? 10.5 : 9.5, options.bold ? "bold" : "normal", options.color || COLORS.text);
    
    if (options.line !== false) {
       doc.setDrawColor(240, 240, 240);
       doc.line(PAGE.margin, y - 5, PAGE.w - PAGE.margin, y - 5);
    }

    doc.text(label, PAGE.w - PAGE.margin - 40, y, { align: "right" });
    doc.text(formatCurrency(amount, options.decimals ?? 2), PAGE.w - PAGE.margin - 4, y, { align: "right" });
    y += 8;
  };

  const drawBullets = (items, indent = PAGE.margin + 3, prefix = "•") => {
    items.forEach((item) => {
      const lines = doc.splitTextToSize(`${prefix} ${item}`, PAGE.w - indent - PAGE.margin);
      ensureSpace(lines.length * LAYOUT.lineHeight + 2);
      // setText(9.5, "normal", COLORS.text);
      setText(FONT.body, "normal", COLORS.text);
      doc.text(lines, indent, y);
      y += lines.length * LAYOUT.lineHeight + 1.5;
    });
  };

  const drawManagedBullets = (items, indent = PAGE.margin + 3) => {
    drawBullets(items, indent, "•");
  };

  const drawManagedTable = (headers, rows, widths, options = {}) => {
    const tableWidth = widths.reduce((sum, width) => sum + width, 0);
    const startX = PAGE.margin;

    const drawTableHeader = () => {
      ensureSpace(11);
      doc.setFillColor(...COLORS.tableHeader);
      doc.rect(startX, y, tableWidth, 9, "F");
      // setText(10, "bold", [255, 255, 255]);
      setText(FONT.tableHeader, "bold", [255, 255, 255]);

      let headerX = startX;
      headers.forEach((header, index) => {
        let align = "left";
        let textX = headerX + 4;
        
        if (header.includes("Amount") || header.includes("Total") || header === "Rate" || header.includes("Area")) {
            align = "center";
            textX = headerX + widths[index] / 2;
        }
        if (header === "Amount (INR)") {
            align = "right";
            textX = headerX + widths[index] - 4;
        }

        doc.text(header, textX, y + 6, { align: align });
        headerX += widths[index];
      });
      y += 3 + LAYOUT.smallLineHeight;
    };

    drawTableHeader();

    rows.forEach((row, rowIndex) => {
      const cellHeights = row.map((cell, index) => {
         const lines = doc.splitTextToSize(String(cell), widths[index] - 8);
         return lines.length * LAYOUT.smallLineHeight + 8;
      });
      const hasSubtitle = Array.isArray(row[0]);
      let rowHeight = Math.max(...cellHeights);
      if (hasSubtitle) {
         const titleLines = doc.splitTextToSize(row[0][0], widths[0] - 8);
         const subLines = doc.splitTextToSize(row[0][1], widths[0] - 8);
         rowHeight = Math.max(rowHeight, (titleLines.length + subLines.length) * LAYOUT.smallLineHeight + 10);
      }

      if (y + rowHeight > PAGE.h - PAGE.margin - 15) {
        doc.addPage();
        pageNum++;
        startPage(false);
        drawTableHeader();
      }

      const isTotalRow = row[0] === "Total";
      if (isTotalRow) {
         doc.setFillColor(...COLORS.soft);
         doc.rect(startX, y, tableWidth, rowHeight, "F");
      }

      doc.setDrawColor(240, 240, 240);
      doc.line(startX, y + rowHeight, startX + tableWidth, y + rowHeight);

      let cursorX = startX;
      row.forEach((cell, index) => {
        if (index === 0 && hasSubtitle) {
            setText(10, "bold", COLORS.text);
            const tLines = doc.splitTextToSize(cell[0], widths[index] - 8);
            doc.text(tLines, cursorX + 4, y + 6);
            // setText(9, "normal", COLORS.muted);
            setText(FONT.small, "normal", COLORS.muted);
            const sLines = doc.splitTextToSize(cell[1], widths[index] - 8);
            doc.text(sLines, cursorX + 4, y + 6 + tLines.length * LAYOUT.smallLineHeight + 1);
        } else {
            // setText(9.5, isTotalRow ? "bold" : "normal", COLORS.text);
            setText(FONT.body, isTotalRow ? "bold" : "normal", COLORS.text);
            const lines = doc.splitTextToSize(String(cell), widths[index] - 8);
            let align = "left";
            let textX = cursorX + 4;
            
            if (headers[index].includes("Amount") || headers[index].includes("Total") || headers[index] === "Rate" || headers[index].includes("Area")) {
                align = "center";
                textX = cursorX + widths[index] / 2;
            }
            if (headers[index] === "Amount (INR)") {
                align = "right";
                textX = cursorX + widths[index] - 4;
            }
            doc.text(lines, textX, y + 6, { align: align });
        }
        cursorX += widths[index];
      });

      y += rowHeight;
    });

    y += 4;
  };

  const drawPackagePage = (packageKey) => {
    const packageImage = packageImages[packageKey];
    if (packageImage) {
      drawReferenceImagePage(packageImage);
    }
  };

  const drawFooterLastPage = () => {
    if (y > 246) {
      doc.addPage();
      pageNum++;
    }
    
    y = 251;
    
    setText(9, "bold", [0, 0, 0]);
    doc.text(".................................", PAGE.margin + 1, y - 3);
    setText(8.8, "normal", [45, 45, 45]);
    doc.text("Client Signature", PAGE.margin + 6, y + 3);
    
    setText(8.8, "bold", [45, 45, 45]);
    doc.text("Ar. Gajanan V. Shetkar", PAGE.w - PAGE.margin - 1, y - 3, { align: "right" });
    // setText(6.8, "normal", [85, 85, 85]);
    setText(FONT.small, "normal", [85, 85, 85]);
    doc.text("Founder & PrincipalArchitect | CoA:CA/2014/64577", PAGE.w - PAGE.margin - 1, y + 2, { align: "right" });
    
    doc.setFillColor(...COLORS.primary);
    doc.rect(0, 270, PAGE.w, 27, "F");
    
    // setText(17, "bold", [255, 255, 255]);
    setText(FONT.section, "bold", [255, 255, 255]);
    doc.text("DWELLORA DESIGNS LLP", PAGE.w / 2, 282, { align: "center" });
    
    // setText(8.8, "bold", [255, 255, 255]);
    setText(FONT.small, "bold", [255, 255, 255]);

    doc.text("ARCHITECTURE | INTERIOR | TURNKEY CONSTRUCTION", PAGE.w / 2, 288, { align: "center" });
    
    // setText(7.1, "normal", [255, 255, 255]);
    setText(FONT.footer, "normal", [255, 255, 255]);

    doc.text("Office:601,TheStellar,Bhumkar Chowk,Wakad-411057 | M:+919158914222   E: dwellorahomes@gmail.com | W: www.dwellorahomes.com", PAGE.w / 2, 294, { align: "center" });
  };

  const drawReferenceImagePage = (imageData) => {
    nextPage();
    doc.addImage(imageData, "JPEG", 0, 0, PAGE.w, PAGE.h);
    y = PAGE.h;
  };

  const drawScopePage = () => {
    drawReferenceImagePage(section3Page1Image);
    drawReferenceImagePage(section3Page2Image);
  };

  const drawGreyStructureSpecificationPage = () => {
    if (greyStructureOnlySpecificationImage) {
      drawReferenceImagePage(greyStructureOnlySpecificationImage);
    }
  };

  const drawPackageSpecificationPage = (packageKey) => {
    const packageSpecificationImage = packageSpecificationImages[packageKey];

    if (packageSpecificationImage) {
      drawReferenceImagePage(packageSpecificationImage);
    }
  };

  const drawPmcSpecificationPage = () => {
    if (pmcSpecificationImage) {
      drawReferenceImagePage(pmcSpecificationImage);
    }
  };

  const drawTermsConditionsPage = () => {
    if (termsGrayPmcImage) {
      drawReferenceImagePage(termsGrayPmcImage);
    }
  };

  const drawArchitectureTermsPage = () => {
    if (architectureTermsImage) {
      drawReferenceImagePage(architectureTermsImage);
    }
  };

  const drawCompleteConstructionTermsPage = () => {
    if (completeConstructionTermsImage) {
      drawReferenceImagePage(completeConstructionTermsImage);
    }
  };

  const FIRST_PAGE_SECTION_TITLE = {
    h: 13,
    fontSize: 15.5,
    textOffsetY: 9.2,
    borderW: 0.8,
    borderH: 13
  };

  const drawFirstPageSectionTitle = (title, sectionY, options = {}) => {
    const x = options.x ?? PAGE.margin + 1;
    const w = options.w ?? PAGE.w - PAGE.margin * 2 - 2;
    const h = options.h ?? FIRST_PAGE_SECTION_TITLE.h;
    const borderH = options.borderH ?? FIRST_PAGE_SECTION_TITLE.borderH;
    const fillColor = options.fillColor ?? [248, 249, 251];
    const borderColor = options.borderColor ?? [0, 0, 0];
    const textColor = options.textColor ?? [36, 54, 70];

    doc.setFillColor(...fillColor);
    doc.rect(x, sectionY, w, h, "F");
    doc.setFillColor(...borderColor);
    doc.rect(x, sectionY + (h - borderH) / 2, FIRST_PAGE_SECTION_TITLE.borderW, borderH, "F");
    setText(options.fontSize ?? FIRST_PAGE_SECTION_TITLE.fontSize, "bold", textColor);
    doc.text(title, x + 7, sectionY + (options.textOffsetY ?? FIRST_PAGE_SECTION_TITLE.textOffsetY));
  };

  const drawFirstPageTableHeader = (x, headerY, widths, headers, options = {}) => {
    const fillColor = options.fillColor ?? COLORS.tableHeader;
    const textColor = options.textColor ?? [255, 255, 255];
    const fontSize = options.fontSize ?? 9.7;
    const height = options.height ?? 12;

    doc.setFillColor(...fillColor);
    doc.rect(x, headerY, widths.reduce((sum, item) => sum + item, 0), height, "F");
    setText(fontSize, "bold", textColor);

    let cursorX = x;
    headers.forEach((header, index) => {
      const align = options.alignments?.[index] ?? (index === headers.length - 1 ? "right" : "left");
      const textX = align === "right"
        ? cursorX + widths[index] - 6
        : align === "center"
          ? cursorX + widths[index] / 2
          : cursorX + 3;
      doc.text(header, textX, headerY + height / 2 + 1.8, { align, baseline: "middle" });
      cursorX += widths[index];
    });
  };

  const getConstructionCostTitle = () => {
    if (data.packageType && estimate.selectedPackageName) {
      return `2.0 Construction Cost ( ${estimate.selectedPackageName} Package )`;
    }

    if (data.construction === "grey") {
      return "2.0 Construction Cost ( Grey Structure )";
    }

    if (data.construction === "pmc") {
      return "2.0 Project Cost Summary";
    }

    if (data.construction === "none") {
      return "2.0 Estimated Construction Value (Reference Only)";
    }

    return "2.0 Construction Cost";
  };

  const getPaymentMilestonesTitle = () =>
    isNoConstructionService
      ? "5.0 Construction Payment Milestones"
      : isGreyStructure || isPMCConstruction
      ? "6.0 Construction Payment Milestones"
      : "7.0 Construction Payment Milestones";

  const getPaymentMilestones = () =>
    isNoConstructionService ? NO_CONSTRUCTION_PAYMENT_MILESTONES : PAYMENT_MILESTONES;

  const getConsultancySummaryLabel = () => {
    const parts = [];

    if (data.architecture) parts.push("Architecture");
    if (estimate.liaisonFee > 0) parts.push("Liaisoning");
    if (data.construction === "pmc") parts.push("PMC");

    if (!parts.length) return "Consultancy Charges";
    if (parts.length === 1) return `${parts[0]} Consultancy`;
    if (parts.length === 2) return `${parts[0]} & ${parts[1]} Consultancy`;

    return `${parts.slice(0, -1).join(", ")} & ${parts[parts.length - 1]} Consultancy`;
  };

  const drawConsultancyGrossFeeRow = (tableX, tableW, startY) => {
    let currentY = startY;

    setText(11, "bold", [0, 0, 0]);
    doc.text("Total Gross Fee:", tableX + 126, currentY + 5.5, { align: "right" });
    setText(11.2, "bold", COLORS.text);
    doc.text(
      formatCurrency(estimate.grossConsultancyFee, 2),
      tableX + tableW - 6,
      currentY + 5.5,
      { align: "right" }
    );

    doc.setDrawColor(238, 238, 238);
    doc.line(tableX, currentY + 10, tableX + tableW, currentY + 10);
    currentY += 13;

    return currentY;
  };

  const drawConsultancySummaryTail = (tableX, tableW, startY) => {
    let currentY = startY;

    if (estimate.discount > 0) {
      setText(10.8, "bold", [31, 184, 117]);
      doc.text(`${estimate.discountLabel}:`, tableX + 126, currentY + 4.5, { align: "right" });
      doc.text(
        formatCurrency(estimate.discount, 2),
        tableX + tableW - 6,
        currentY + 4.5,
        { align: "right" }
      );
      doc.setDrawColor(238, 238, 238);
      doc.line(tableX, currentY + 9.5, tableX + tableW, currentY + 9.5);
      currentY += 13;
    }

    doc.setFillColor(248, 249, 251);
    doc.rect(tableX, currentY, tableW, 12, "F");
    setText(11.2, "bold", [0, 0, 0]);
    doc.text("Final Consultancy Fee (Excluding Govt. Taxes):", tableX + 3, currentY + 7.8);
    setText(11.4, "bold", [0, 0, 0]);
    doc.text(
      formatCurrency(estimate.finalConsultancyFee, 2),
      tableX + tableW - 6,
      currentY + 7.8,
      { align: "right" }
    );

    return currentY + 13;
  };

  let carryConsultancyTailToProjectPage = false;

  const drawProjectCostPage = () => {
    nextPage();

    const tableX = PAGE.margin + 1;
    const tableW = PAGE.w - PAGE.margin * 2 - 2;
    let sectionY = 18;
    const costWidths = [93, 34, 22, tableW - 93 - 34 - 22];

    if (carryConsultancyTailToProjectPage) {
      sectionY = drawConsultancySummaryTail(tableX, tableW, sectionY) + 8;
    }

    const tableTopY = sectionY + 16;
    const costRowH = 12.4;

    drawFirstPageSectionTitle(getConstructionCostTitle(), sectionY, {
      x: tableX,
      w: tableW
    });

    drawFirstPageTableHeader(
      tableX,
      tableTopY,
      costWidths,
      ["Work Component", "Area (sq.Ft)", "Rate", "Total (INR)"],
      {
        fillColor: [248, 249, 251],
        textColor: [0, 0, 0],
        alignments: ["left", "center", "center", "right"],
        fontSize: 11.5,
        height: 12
      }
    );

    let currentY = tableTopY + 14;

    estimate.final.forEach((item) => {
      const labelLines = doc.splitTextToSize(item.label, costWidths[0] - 8);
      const labelLineHeight = 4.9;
      const labelBlockHeight = labelLines.length * labelLineHeight;
      const verticalPadding = labelLines.length > 1 ? 8.4 : 5.4;
      const rowHeight = Math.max(costRowH, labelBlockHeight + verticalPadding);
      const labelTextY = currentY + (rowHeight - labelBlockHeight) / 2 + 1.6;
      const valueTextY = currentY + rowHeight / 2;

      setText(11, "normal", [20, 20, 20]);
      doc.text(labelLines, tableX + 3, labelTextY, {
        lineHeightFactor: 1.1
      });
      doc.text(formatCurrency(item.area, 0), tableX + costWidths[0] + costWidths[1] / 2, valueTextY, {
        align: "center",
        baseline: "middle"
      });
      doc.text(
        formatCurrency(item.rate, 0),
        tableX + costWidths[0] + costWidths[1] + costWidths[2] / 2,
        valueTextY,
        {
          align: "center",
          baseline: "middle"
        }
      );
      doc.text(formatCurrency(item.cost, 2), tableX + tableW - 3, valueTextY, {
        align: "right",
        baseline: "middle"
      });

      doc.setDrawColor(238, 238, 238);
      doc.line(tableX, currentY + rowHeight, tableX + tableW, currentY + rowHeight);
      currentY += rowHeight;
    });

    const summaryRows = isNoConstructionService
      ? [
          {
            label: "Estimated Construction Value (Reference Only)",
            value: estimate.constructionTotal,
            fill: null
          },
          estimate.architectureFee > 0
            ? {
                label: "Architecture Consultancy Fee @4%",
                value: estimate.architectureFee,
                fill: null
              }
            : null,
          estimate.liaisonFee > 0
            ? {
                label: "Liaisoning & Authority Approvals",
                value: estimate.liaisonFee,
                fill: null
              }
            : null,
          {
            label: "Final Consultancy Fee Payable",
            value: estimate.finalConsultancyFee,
            fill: [232, 238, 242]
          }
        ].filter(Boolean)
      : [
          {
            label: "Total Construction cost",
            value: estimate.constructionTotal,
            fill: null
          },
          estimate.finalConsultancyFee > 0
            ? {
                label: getConsultancySummaryLabel(),
                value: estimate.finalConsultancyFee,
                fill: null
              }
            : null,
          {
            label: "Total Cost of Project",
            value: estimate.finalTotal,
            fill: [232, 238, 242]
          }
        ].filter(Boolean);

    currentY += 3;

    summaryRows.forEach((row) => {
      if (row.fill) {
        doc.setFillColor(...row.fill);
        doc.rect(tableX, currentY, tableW, 10, "F");
      }

      doc.setDrawColor(238, 238, 238);
      doc.line(tableX, currentY + 10, tableX + tableW, currentY + 10);

      setText(9.8, "bold", [20, 20, 20]);
      doc.text(row.label, tableX + 3, currentY + 6.6);
      doc.text(formatCurrency(row.value, 2), tableX + tableW - 3, currentY + 6.6, {
        align: "right"
      });

      currentY += 13;
    });
  };

  const drawFirstPage = () => {
    const isPMCConsultancyLayout = data.construction === "pmc";
    pageNum = 1;
    doc.setFillColor(...COLORS.primary);
    doc.rect(0, 0, PAGE.w, 41.5, "F");

    setText(23, "bold", [255, 255, 255]);
    doc.text("DWELLORA HOMES", PAGE.margin + 1, 23.5);
    setText(13, "script", [238, 221, 244]);
    doc.text("A Venture by Dwellora Designs LLP", PAGE.margin + 1, 32);

    setText(17.5, "bold", [255, 255, 255]);
    doc.text("QUOTATION", PAGE.w - PAGE.margin - 6, 20.5, { align: "right" });
    setText(11, "normal", [255, 255, 255]);
    doc.text(`Ref: ${quotationRef}`, PAGE.w - PAGE.margin - 6, 29, { align: "right" });
    doc.text(`Date: ${new Date().toLocaleDateString("en-GB").replace(/\//g, ".")}`, PAGE.w - PAGE.margin - 6, 36, { align: "right" });

    drawFirstPageSectionTitle("1. PROJECT OVERVIEW", 58);

    const overviewLeftX = PAGE.margin + 5;
    const overviewRightX = 108;
    const overviewRightValueX = 154;
    const overviewValueOffset = 33;
    const overviewLineStart = PAGE.margin + 2;
    const overviewLineEnd = PAGE.w - PAGE.margin - 2;
    const overviewLineHeightFactor = 1.24;
    const overviewTextLineHeight = 5.1;
    const overviewTextStartOffset = isPMCConsultancyLayout ? 7.8 : 8.2;
    const overviewBottomPadding = isPMCConsultancyLayout ? 4.4 : 4.2;

    const drawOverviewRow = (rowY, leftLabel, leftValue, rightLabel, rightValue, options = {}) => {
      const leftLines = doc.splitTextToSize(leftValue || "-", options.leftWidth ?? 55);
      const rightLines = rightLabel
        ? doc.splitTextToSize(rightValue || "-", options.rightWidth ?? overviewLineEnd - overviewRightValueX)
        : [];
      const contentLineCount = Math.max(leftLines.length, rightLines.length || 1);
      const rowHeight = Math.max(
        isPMCConsultancyLayout ? 15 : 14,
        overviewTextStartOffset + (contentLineCount - 1) * overviewTextLineHeight + overviewBottomPadding
      );
      const textY = rowY + overviewTextStartOffset;

      setText(11.5, "bold", COLORS.label);
      doc.text(leftLabel, overviewLeftX, textY);
      setText(11.2, "normal", COLORS.text);
      doc.text(leftLines, overviewLeftX + overviewValueOffset, textY, {
        lineHeightFactor: overviewLineHeightFactor
      });

      if (rightLabel) {
        setText(11.5, "bold", COLORS.label);
        doc.text(rightLabel, overviewRightX, textY);
        setText(11.2, "normal", COLORS.text);
        doc.text(rightLines, options.rightValueX ?? overviewRightValueX, textY, {
          lineHeightFactor: overviewLineHeightFactor
        });
      }

      if (options.showBorder !== false) {
        doc.setDrawColor(228, 232, 236);
        doc.setLineWidth(0.25);
        doc.line(overviewLineStart, rowY + rowHeight, overviewLineEnd, rowY + rowHeight);
      }

      return rowHeight + 2;
    };

    y = 79;
    y += drawOverviewRow(
      y,
      "Client Name:",
      data.name || "-",
      "Building Type:",
      getDisplayBuildingType(data.buildingType),
      { leftWidth: 46, rightWidth: 40 }
    );

    y += drawOverviewRow(
      y,
      "Address :",
      getProjectAddress(data),
      "Construction Type:",
      getDisplayConstructionType(data),
      { leftWidth: 46, rightWidth: 40 }
    );

    y += drawOverviewRow(
      y,
      "Plot Area :",
      `${formatCurrency(data.area || 0)} Sq.Ft`,
      "Mobile No.:",
      data.mobile || "-",
      { rightWidth: 40, showBorder: false }
    );

    const consultancySectionY = Math.max(isPMCConsultancyLayout ? 130 : 136, y + (isPMCConsultancyLayout ? 0 : 2));
    const consultancyHeaderY = consultancySectionY + (isPMCConsultancyLayout ? 13.5 : 15);
    const consultancyRowsStartY = consultancyHeaderY + (isPMCConsultancyLayout ? 17 : 18.5);

    drawFirstPageSectionTitle("1.0 ARCHITECTURAL CONSULTANCY FEES", consultancySectionY, {
      x: PAGE.margin + 1,
      w: PAGE.w - PAGE.margin * 2 - 2
    });

    const tableX = PAGE.margin + 1;
    const tableW = PAGE.w - PAGE.margin * 2 - 2;
    const consultancyWidths = [126, tableW - 126];
    drawFirstPageTableHeader(tableX, consultancyHeaderY, consultancyWidths, ["Service Description", "Amount (INR)"], {
      fillColor: [248, 249, 251],
      textColor: [0, 0, 0],
      fontSize: 12,
      height: 12
    });

    const consultancyRows = [
      data.architecture ? {
        title: "Comprehensive Architecture Design",
        desc: "Concept designs, 3D views, working drawings (RCC, Electrical, Plumbing),\n& site layouts.\n( Calculated @ 4% of total project cost. )",
        amount: estimate.architectureFee
      } : null,
      estimate.liaisonFee > 0 ? {
        title: `${data.liaison || "Authority"} Liaisoning Consultancy`,
        desc: "Sanction drawings, area calculations, and file processing with local authorities.\n( Applicable up to 2500 sq.ft plot area. )",
        amount: estimate.liaisonFee
      } : null,
      data.construction === "pmc" ? {
        title: "Project Management Consultancy - File Process",
        desc: "End-to-end construction support to manage your project smoothly from planning to final execution.\n\nTotal fees : 10% of total cost",
        amount: estimate.pmcFee
      } : null
    ].filter(Boolean);

    y = consultancyRowsStartY;
    consultancyRows.forEach((row) => {
      const descLines = doc.splitTextToSize(row.desc, 126);
      const rowHeight = Math.max(
        isPMCConsultancyLayout ? 29 : 31,
        (isPMCConsultancyLayout ? 10 : 11) + descLines.length * (isPMCConsultancyLayout ? 5.1 : 5.3)
      );
      const contentY = y + (isPMCConsultancyLayout ? 5 : 5.5);

      setText(11, "bold", COLORS.label);
      doc.text(row.title, tableX + 3, contentY);

      setText(isPMCConsultancyLayout ? 10.3 : 10.6, "normal", COLORS.text);
      doc.text(descLines, tableX + 3, contentY + 6.2, {
        lineHeightFactor: 1.28
      });

      setText(11.2, "normal", COLORS.text);
      doc.text(
        formatCurrency(row.amount, 2),
        tableX + tableW - 6,
        contentY,
        {
          align: "right"
        }
      );

      doc.setDrawColor(238, 238, 238);
      doc.setLineWidth(0.25);
      doc.line(tableX, y + rowHeight, tableX + tableW, y + rowHeight);
      y += rowHeight + (isPMCConsultancyLayout ? 3.5 : 5);
    });

    y = drawConsultancyGrossFeeRow(tableX, tableW, y);

    if (data.construction === "pmc") {
      carryConsultancyTailToProjectPage = true;
    } else {
      y = drawConsultancySummaryTail(tableX, tableW, y);
    }
  };

  drawFirstPage();
  drawProjectCostPage();

  /*
  startPage(true);

  drawSection("1. PROJECT OVERVIEW");
  drawInfoGrid([
    { label: "Client Name:", value: data.name || "-" },
    { label: "Plot Area :", value: `${formatCurrency(data.area || 0)} Sq.Ft` },
    { label: "Address :", value: data.society || "-" },
    { label: "Building Type:", value: getDisplayBuildingType(data.buildingType) },
    { label: "Construction Type:", value: getDisplayConstructionType(data) }
  ]);

  y += 6;

  drawSection("1.0 ARCHITECTURAL CONSULTANCY FEES");
  drawManagedTable(
    ["Service Description", "Amount (INR)"],
    [
      data.architecture ? [
        ["Comprehensive Architecture Design", "Concept designs, 3D views, working drawings (RCC, Electrical, Plumbing),\n& site layouts.\n( Calculated @ 5% of total project cost. )"],
        formatCurrency(estimate.architectureFee, 2)
      ] : null,
      estimate.liaisonFee > 0 ? [
        [`${data.liaison || "Authority"} Liaisoning Consultancy`, "Sanction drawings, area calculations, and file processing with local authorities.\n( Applicable up to 2500 sq.ft plot area. )"],
        formatCurrency(estimate.liaisonFee, 2)
      ] : null,
      data.construction === "pmc" ? [
        ["Project Management Consultancy", "Site supervision, material management and quality control."],
        formatCurrency(estimate.pmcFee, 2)
      ] : null,
    ].filter(Boolean),
    [125, 55]
  );

  y += 4;

  drawAmountRow("Total Gross Fee:", estimate.grossConsultancyFee, {
    bold: false,
    decimals: 2,
    line: false
  });

  if (estimate.discount > 0) {
    drawAmountRow(`${estimate.discountLabel}:`, -estimate.discount, {
      color: COLORS.success,
      bold: true,
      decimals: 2,
      line: false
    });
  }

  drawAmountRow("Final Consultancy Fee (Excluding Govt. Taxes):", estimate.finalConsultancyFee, {
    bold: true,
    decimals: 2,
    line: true
  });

  y += 8;

  startFlowSection("2.0 ESTIMATED PROJECT COST (RCC + FINISHING)", 140);
  drawManagedTable(
    ["Work Component", "Area (Sq.Ft)", "Rate", "Total (INR)"],
    estimate.final.map((item) => [
      item.label,
      formatCurrency(item.area, 0),
      formatCurrency(item.rate, 0),
      formatCurrency(item.cost, 2)
    ]),
    [78, 32, 22, 48]
  );

  y += 2;
  
  doc.setFillColor(...COLORS.soft);
  doc.rect(PAGE.margin, y, PAGE.w - PAGE.margin * 2, 10, "F");
  setText(9.5, "bold", COLORS.text);
  doc.text("Total Project Value (Including Consultancy Fees):", PAGE.margin + 4, y + 6.5);
  doc.text(formatCurrency(estimate.finalTotal, 2), PAGE.w - PAGE.margin - 16, y + 6.5, { align: "right" });
  
  y += 16;
  
  setText(9, "bold", COLORS.text);
  doc.text(`In words: ${amountToWords(estimate.finalTotal)}.`, PAGE.margin, y);
  y += 12;
  */

  drawScopePage();

  /*
  startFlowSection("3.0 DETAILED SCOPE OF SERVICES AND SCHEDULES", 130);

  setText(9.5, "normal", COLORS.text);
  let simY1 = 0;
  simY1 += 12;
  staticContent.scopeOfServices.architecturalDesign.studyAnalysis.forEach(item => {
      const lines = doc.splitTextToSize(`• ${item}`, PAGE.w - PAGE.margin * 2 - 6);
      simY1 += lines.length * LAYOUT.lineHeight + 1.5;
  });
  simY1 += 10;
  staticContent.scopeOfServices.architecturalDesign.designPhase.forEach(item => {
      const lines = doc.splitTextToSize(`• ${item}`, PAGE.w - PAGE.margin * 2 - 6);
      simY1 += lines.length * LAYOUT.lineHeight + 1.5;
  });
  simY1 += 10;
  staticContent.scopeOfServices.architecturalDesign.siteLayout.forEach(item => {
      const lines = doc.splitTextToSize(`• ${item}`, PAGE.w - PAGE.margin * 2 - 6);
      simY1 += lines.length * LAYOUT.lineHeight + 1.5;
  });
  let boxH1 = simY1 + 4;

  ensureSpace(boxH1 + 10);
  drawColoredHeaderSection("3.1 Architectural Design & Drawings Services");
  
  const startY1 = y;
  doc.setFillColor(...COLORS.soft);
  doc.rect(PAGE.margin, startY1, PAGE.w - PAGE.margin * 2, boxH1, "F");
  
  y += 6;
  setText(9.5, "bold", COLORS.text);
  doc.text("a) To Study and Analysis of :", PAGE.margin + 4, y);
  y += 6;
  drawBullets(staticContent.scopeOfServices.architecturalDesign.studyAnalysis, PAGE.margin + 6);
  
  y += 4;
  setText(9.5, "bold", COLORS.text);
  doc.text("b) Preparation of Concept Design & Presentation Drawings.", PAGE.margin + 4, y);
  y += 6;
  drawBullets(staticContent.scopeOfServices.architecturalDesign.designPhase, PAGE.margin + 6);
  
  y += 4;
  setText(9.5, "bold", COLORS.text);
  doc.text("c) Preparation of Site Layout Consideration :", PAGE.margin + 4, y);
  y += 6;
  drawBullets(staticContent.scopeOfServices.architecturalDesign.siteLayout, PAGE.margin + 6);

  y += 12;

  const wD1 = ["Preparation of Setting Out plan", "Preparation of Centre line plan", "Preparation of working drawings for RCC, structural steel & allied infrastructure\nworks", "Preparation of all floor plans with dimensions & details", "Preparation of all elevations & sections with dimension details", "Preparation of Position drawings for UG tank, septic tank"];
  
  setText(10, "bold", COLORS.text);
  let simY2 = 8;
  wD1.forEach((item) => {
     const lines = doc.splitTextToSize(item, PAGE.w - PAGE.margin * 2 - 12);
     simY2 += lines.length * LAYOUT.lineHeight + 4;
  });
  let boxH2 = simY2 + 4;

  ensureSpace(boxH2 + 10);
  drawColoredHeaderSection("3.2 Working Drawings / Execution Drawings (WD-50)");
  
  const startY2 = y;
  doc.setFillColor(...COLORS.soft);
  doc.rect(PAGE.margin, startY2, PAGE.w - PAGE.margin * 2, boxH2, "F");
  
  y += 8;
  const letters1 = ["a)", "b)", "c)", "d)", "e)", "f)"];
  wD1.forEach((item, i) => {
     setText(10, "bold", COLORS.text);
     doc.text(letters1[i], PAGE.margin + 4, y);
     const lines = doc.splitTextToSize(item, PAGE.w - PAGE.margin * 2 - 12);
     doc.text(lines, PAGE.margin + 10, y);
     y += lines.length * LAYOUT.lineHeight + 4;
  });
  
  y += 12;

  const wD2 = ["Preparation of staircase & toilet details drawings", "Preparation of detail drawings of compound wall, entrance gate, fabrication work\nMain gate etc.", "Preparation of door & window schedules and detail drawings with specification", "Electrical Layout", "Plumbing layout"];
  
  setText(10, "bold", COLORS.text);
  let simY3 = 8;
  wD2.forEach((item) => {
     const lines = doc.splitTextToSize(item, PAGE.w - PAGE.margin * 2 - 12);
     simY3 += lines.length * LAYOUT.lineHeight + 4;
  });
  let boxH3 = simY3 + 4;

  ensureSpace(boxH3 + 10);
  drawColoredHeaderSection("3.3 Working Drawings (WD-100)");
  
  const startY3 = y;
  doc.setFillColor(...COLORS.soft);
  doc.rect(PAGE.margin, startY3, PAGE.w - PAGE.margin * 2, boxH3, "F");
  
  y += 8;
  const letters2 = ["a)", "b)", "c)", "d)", "e)"];
  wD2.forEach((item, i) => {
     setText(10, "bold", COLORS.text);
     doc.text(letters2[i], PAGE.margin + 4, y);
     const lines = doc.splitTextToSize(item, PAGE.w - PAGE.margin * 2 - 12);
     doc.text(lines, PAGE.margin + 10, y);
     y += lines.length * LAYOUT.lineHeight + 4;
  });
  
  y += 12;

  */

  if (isCompleteConstruction) {
    if (data.packageType) {
      drawPackagePage(data.packageType);
      drawPackageSpecificationPage(data.packageType);
    }
    drawCompleteConstructionTermsPage();
  } else if (isNoConstructionService) {
    drawArchitectureTermsPage();
  } else if (isGreyStructure) {
    drawGreyStructureSpecificationPage();
    drawTermsConditionsPage();
  } else if (isPMCConstruction) {
    drawPmcSpecificationPage();
    drawTermsConditionsPage();
  }

  /*
  setText(9.5, "normal", COLORS.text);
  let simY5 = 6;
  staticContent.specifications.rccWork.items.forEach((item, index) => {
      const prefix = `${index + 1}. `;
      const lines = doc.splitTextToSize(item, PAGE.w - PAGE.margin * 2 - 8 - doc.getTextWidth(prefix));
      simY5 += lines.length * LAYOUT.lineHeight + 1.5;
  });
  let boxH5 = simY5 + 4;

  startFlowSection("5.0 SPECIFICATIONS FOR CONSTRUCTION", boxH5 + 30);
  
  ensureSpace(boxH5 + 20);
  drawColoredHeaderSection("5.1 R.C.C WORK and Finishing Items");
  
  const startY5 = y;
  doc.setDrawColor(...COLORS.border);
  doc.setFillColor(255, 255, 255);
  doc.rect(PAGE.margin, startY5, PAGE.w - PAGE.margin * 2, boxH5, "FD");
  
  y += 6;
  staticContent.specifications.rccWork.items.forEach((item, index) => {
      const prefix = `${index + 1}. `;
      setText(9.5, "normal", COLORS.text);
      doc.text(prefix, PAGE.margin + 4, y);
      
      const textX = PAGE.margin + 4 + doc.getTextWidth(prefix);
      const lines = doc.splitTextToSize(item, PAGE.w - PAGE.margin * 2 - 8 - doc.getTextWidth(prefix));
      
      setText(9.5, "normal", COLORS.text);
      doc.text(lines, textX, y);
      
      y += lines.length * LAYOUT.lineHeight + 1.5;
  });
  
  y += 12;

  */

  nextPage();

  const PAYMENT_MILESTONES_SECTION_TOP_Y = 31;
  const PAYMENT_MILESTONES_TABLE_START_GAP = 19;
  const payX = PAGE.margin + 1;
  const payW = PAGE.w - PAGE.margin * 2 - 2;
  y = PAYMENT_MILESTONES_SECTION_TOP_Y;

  drawFirstPageSectionTitle(getPaymentMilestonesTitle(), y, {
    x: payX,
    w: payW,
    h: 13,
    borderH: 13,
    fontSize: 15.5,
    textOffsetY: 9.2
  });
  y += PAYMENT_MILESTONES_TABLE_START_GAP;

  const payCols = [104, 42, payW - 146];
  const rowH = 12.4;

  doc.setFillColor(...COLORS.tableHeader);
  doc.rect(payX, y, payW, rowH, "F");
  setText(11.5, "bold", [255, 255, 255]);
  doc.text("Stage", payX + 2, y + 7.9);
  doc.text("%", payX + payCols[0] + payCols[1] / 2, y + 7.9, { align: "center" });
  doc.text("Amount (INR)", payX + payW - 2, y + 7.9, { align: "right" });
  y += rowH;

  const paymentRows = getPaymentMilestones().map((item) => [
    item.label,
    `${item.percent}%`,
    formatCurrency((estimate.finalTotal * item.percent) / 100, 2)
  ]);
  paymentRows.push(["Total", "100%", formatCurrency(estimate.finalTotal, 2)]);

  paymentRows.forEach((row, index) => {
    const isTotal = index === paymentRows.length - 1;

    if (isTotal) {
      doc.setFillColor(248, 249, 251);
      doc.rect(payX, y, payW, rowH, "F");
    }

    setText(11, isTotal ? "bold" : "normal", [0, 0, 0]);
    doc.text(row[0], payX + 2, y + 7.8);
    doc.text(row[1], payX + payCols[0] + payCols[1] / 2, y + 7.8, { align: "center" });
    doc.text(row[2], payX + payW - 2, y + 7.8, { align: "right" });

    doc.setDrawColor(238, 238, 238);
    doc.setLineWidth(0.25);
    doc.line(payX, y + rowH, payX + payW, y + rowH);
    y += rowH;
  });

  drawFooterLastPage();

  /*
  setText(9.5, "normal", COLORS.text);
  let simY7 = 8;
  Object.values(staticContent.termsConditions.sections).forEach((sectionData) => {
      simY7 += 8;
      sectionData.items.forEach(item => {
          const lines = doc.splitTextToSize(`• ${item}`, PAGE.w - PAGE.margin * 2 - 12);
          simY7 += lines.length * LAYOUT.lineHeight + 1.5;
      });
      simY7 += 4;
  });
  let boxH7 = simY7 + 4;

  startFlowSection("7.0 TERMS, CONDITIONS & EXCLUSIONS", boxH7 + 10);
  ensureSpace(boxH7 + 5);

  const startY7 = y;
  doc.setDrawColor(...COLORS.border);
  doc.setFillColor(255, 255, 255);
  doc.rect(PAGE.margin, startY7, PAGE.w - PAGE.margin * 2, boxH7, "FD");
  
  y += 8;
  Object.values(staticContent.termsConditions.sections).forEach((sectionData) => {
      setText(9.5, "bold", COLORS.label);
      doc.text(sectionData.title, PAGE.margin + 4, y);
      y += 6;
      
      sectionData.items.forEach(item => {
          const lines = doc.splitTextToSize(`• ${item}`, PAGE.w - PAGE.margin * 2 - 12);
          setText(9.5, "normal", COLORS.text);
          doc.text(lines, PAGE.margin + 6, y);
          y += lines.length * LAYOUT.lineHeight + 1.5;
      });
      y += 4;
  });
  y += 12;

  drawFooterLastPage();
  */

  return doc.output("blob");
};

/* eslint-disable no-unused-vars */
const generatePerfectPDFReference = (data, estimate) => {
  if (!estimate || !estimate.final?.length) {
    alert("Unable to generate quotation. Estimate calculation is missing.");
    return;
  }

  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const PAGE = { w: 210, h: 297, margin: 13 };
  const TEXT = [0, 0, 0];
  let y = PAGE.margin;

  const setText = (size, style = "normal", color = TEXT) => {
    doc.setFont("helvetica", style);
    doc.setFontSize(size);
    doc.setTextColor(...color);
  };

  const addPage = () => {
    doc.addPage();
    y = PAGE.margin;
  };

  const ensureSpace = (height) => {
    if (y + height > PAGE.h - PAGE.margin) addPage();
  };

  const text = (value, x, textY, options = {}) => {
    doc.text(String(value ?? ""), x, textY, options);
  };

  const lines = (value, width) => doc.splitTextToSize(String(value || ""), width);

  const paragraph = (value, x = PAGE.margin, width = PAGE.w - PAGE.margin * 2, size = 9.2, lineGap = 4.8) => {
    const splitLines = lines(value, width);
    ensureSpace(splitLines.length * lineGap + 2);
    setText(size);
    doc.text(splitLines, x, y);
    y += splitLines.length * lineGap + 2.4;
  };

  const section = (title, forceNewPage = false) => {
    if (forceNewPage) addPage();
    ensureSpace(12);
    setText(11, "bold");
    text(title, PAGE.margin, y);
    y += 9;
  };

  const subSection = (title) => {
    ensureSpace(10);
    setText(10, "bold");
    text(title, PAGE.margin, y);
    y += 8;
  };

  const table = (headers, rows, columns, options = {}) => {
    const rowGap = options.rowGap || 6.2;
    const headerGap = options.headerGap || 7;
    const fontSize = options.fontSize || 9.2;

    ensureSpace(15);
    setText(fontSize, "bold");
    headers.forEach((header, index) => {
      const col = columns[index];
      text(header, PAGE.margin + col.x, y, { align: col.align || "left" });
    });
    y += headerGap;

    rows.forEach((row) => {
      const cellLines = row.map((cell, index) => lines(cell, columns[index].width || 30));
      const rowHeight = Math.max(rowGap, Math.max(...cellLines.map((item) => item.length)) * 4.8 + 1.5);
      ensureSpace(rowHeight);

      cellLines.forEach((cell, index) => {
        const col = columns[index];
        setText(fontSize, row[0] === "Total" ? "bold" : "normal");
        doc.text(cell, PAGE.margin + col.x, y, { align: col.align || "left" });
      });
      y += rowHeight;
    });

    y += options.afterGap ?? 4;
  };

  const bulletList = (items) => {
    items.forEach((item) => paragraph("- " + item, PAGE.margin + 7, 165, 9.2, 4.8));
  };

  const packageRows = (packageKey) => {
    if (typeof categoryData === "undefined") return [];
    return categoryData.map((item) => [item.title, item[packageKey] || "-"]);
  };

  const paymentMilestones = data.construction === "none"
    ? NO_CONSTRUCTION_PAYMENT_MILESTONES
    : PAYMENT_MILESTONES;

  const drawHeader = () => {
    y = 14;
    setText(18);
    text("DWELLORA HOMES", PAGE.margin, y);
    setText(12, "bold");
    text("QUOTATION", PAGE.w - PAGE.margin, y, { align: "right" });

    y += 7;
    setText(8.5);
    text("A Venture by Dwellora Designs LLP", PAGE.margin, y);
    text(`Ref: DD/${new Date().getFullYear()}/MAM-165`, PAGE.w - PAGE.margin, y, { align: "right" });
    y += 6;
    text(`Date: ${new Date().toLocaleDateString("en-GB").replace(/\//g, ".")}`, PAGE.w - PAGE.margin, y, { align: "right" });
    y = 43;
  };

  const drawProjectOverview = () => {
    section("1. PROJECT OVERVIEW");

    setText(9.2, "bold");
    text("Client Name:", PAGE.margin, y);
    setText(9.2);
    text(data.name || "-", PAGE.margin + 27, y);
    setText(9.2, "bold");
    text("Plot Area :", PAGE.margin + 78, y);
    setText(9.2);
    text(`${formatCurrency(data.area || 0)} Sq.Ft`, PAGE.margin + 103, y);
    y += 8;

    setText(9.2, "bold");
    text("Address :", PAGE.margin, y);
    setText(9.2);
    const address = lines(data.society || "-", 62);
    doc.text(address, PAGE.margin + 27, y);

    setText(9.2, "bold");
    text("Building Type:", PAGE.margin + 78, y);
    setText(9.2);
    text(getDisplayBuildingType(data.buildingType), PAGE.margin + 110, y);
    y += Math.max(8, address.length * 5);

    setText(9.2, "bold");
    text("Construction Type:", PAGE.margin + 78, y);
    setText(9.2);
    text(getDisplayConstructionType(data), PAGE.margin + 117, y);
    y += 12;
  };

  const drawConsultancyFees = () => {
    section("1.0 ARCHITECTURAL CONSULTANCY FEES");
    table(
      ["Service Description", "Amount (INR)"],
      [
        data.architecture ? [
          "Comprehensive Architecture Design\nConcept designs, 3D views, working drawings (RCC, Electrical, Plumbing), & site layouts.",
          formatCurrency(estimate.architectureFee, 2),
        ] : null,
        estimate.liaisonFee > 0 ? [
          `${data.liaison || "Authority"} Liaisoning Consultancy\nSanction drawings, area calculations, and file processing with local authorities.`,
          formatCurrency(estimate.liaisonFee, 2),
        ] : null,
        data.construction === "pmc" ? [
          "Project Management Consultancy\nSite supervision, material management and quality control.",
          formatCurrency(estimate.pmcFee, 2),
        ] : null,
      ].filter(Boolean),
      [
        { x: 0, width: 118 },
        { x: 176, width: 35, align: "right" },
      ],
      { rowGap: 14, headerGap: 8, afterGap: 3 }
    );

    ensureSpace(estimate.discount > 0 ? 28 : 20);

    const amountX = PAGE.w - PAGE.margin;
    const labelX = PAGE.margin + 111;
    setText(9.2);
    text("Total Gross Fee:", labelX, y);
    text(formatCurrency(estimate.grossConsultancyFee, 2), amountX, y, { align: "right" });
    y += 8;

    if (estimate.discount > 0) {
      text(`${estimate.discountLabel}:`, labelX - 25, y);
      text(formatCurrency(estimate.discount, 2), amountX, y, { align: "right" });
      y += 8;
    }

    setText(9.4, "bold");
    text("Final Consultancy Fee (Excluding Govt. Taxes):", PAGE.margin, y);
    text(formatCurrency(estimate.finalConsultancyFee, 2), amountX, y, { align: "right" });
    y += 12;
  };

  const drawProjectCost = () => {
    section("2.0 ESTIMATED PROJECT COST (RCC + FINISHING)");
    table(
      ["Work Component", "Area (Sq.Ft)", "Rate", "Total (INR)"],
      estimate.final.map((item) => [
        item.label,
        formatCurrency(item.area, 0),
        formatCurrency(item.rate, 0),
        formatCurrency(item.cost, 2),
      ]),
      [
        { x: 0, width: 65 },
        { x: 76, width: 25 },
        { x: 133, width: 22 },
        { x: 177, width: 34, align: "right" },
      ],
      { rowGap: 6.7, headerGap: 8, afterGap: 5 }
    );

    setText(9.3, "bold");
    text("Total Project Value (Including Fees):", PAGE.margin + 112, y);
    text(formatCurrency(estimate.finalTotal, 2), PAGE.w - PAGE.margin, y, { align: "right" });
    y += 11;
    paragraph(`In words: ${amountToWords(estimate.finalTotal)}.`, PAGE.margin, 170);
  };

  const drawScope = () => {
    section("3.0 DETAILED SCOPE OF SERVICES AND SCHEDULES", true);
    subSection("3.1 Architectural Design & Drawings Services");
    paragraph("a) To Study and Analysis of :");
    bulletList([
      "Client requirements",
      "Climate analysis, site topography",
      "Site conditions",
      "Site topography",
      "Internal activity",
    ]);
    y += 3;
    paragraph("b) Preparation of Concept Design & Presentation Drawings.");
    paragraph("c) Preparation of Site Layout Consideration :");
    bulletList([
      "Future expansion",
      "Road networking",
      "Paved areas",
      "UG tank, septic tank positions",
      "Drainage, storm water drains etc.",
    ]);
    [
      "d) Preparation of Site Plan",
      "e) Preparation of All Floor Plans",
      "f) Preparation of All Side Elevations & Necessary Section Drawings",
      "g) Facade Design",
      "h) 3D Views",
      "i) Compound Wall Design & Drawing",
      "j) Preparation of Plinth Layout Service Co-ordinated Plan",
    ].forEach((item) => paragraph(item, PAGE.margin + 2, 170));

    y += 3;
    subSection("3.2 Working Drawings / Execution Drawings (WD-50)");
    [
      "a) Preparation of Setting Out plan",
      "b) Preparation of Centre line plan",
      "c) Preparation of working drawings for RCC, structural steel & allied infrastructure works",
      "d) Preparation of all floor plans with dimensions & details",
      "e) Preparation of all elevations & sections with dimension details",
      "f) Preparation of Position drawings for UG tank, septic tank",
    ].forEach((item) => paragraph(item, PAGE.margin, 170, 9.2, 5.2));

    section("3.3 Working Drawings (WD-100)", true);
    [
      "a) Preparation of staircase & toilet details drawings",
      "b) Preparation of detail drawings of compound wall, entrance gate, fabrication work Main gate etc.",
      "c) Preparation of door & window schedules and detail drawings with specification",
      "d) Electrical Layout",
      "e) Plumbing layout",
    ].forEach((item) => paragraph(item, PAGE.margin, 170, 9.2, 5.2));
  };

  const drawPackage = (title, packageKey, forceNewPage = false) => {
    section(title, forceNewPage);
    table(
      ["Category", "Specification"],
      packageRows(packageKey),
      [
        { x: 0, width: 42 },
        { x: 43, width: 132 },
      ],
      { rowGap: 8, fontSize: 9.1, headerGap: 7, afterGap: 2 }
    );
  };

  const drawPackages = () => {
    section("4.0 LIST OF CIVIL FINISHING ITEMS FOR INTERIOR WORK");
    drawPackage("4.1 Basic Package - Internal Specifications", "basic");
    drawPackage("4.1 Standard Package - Internal Specifications", "standard", true);
    drawPackage("4.1 Premium Package - Internal Specifications", "premium", true);
  };

  const drawSpecifications = () => {
    section("5.0 SPECIFICATIONS FOR CONSTRUCTION", true);
    subSection("5.1 R.C.C WORK and finishing items");
    staticContent.specifications.rccWork.items.forEach((item, index) => {
      paragraph(`${index + 1}. ${item}`, PAGE.margin + 2, 172, 9.1, 4.9);
      if (index === 1) {
        y += 2;
        paragraph("A) R.C.C WORK and finishing items", PAGE.margin, 172, 9.2, 4.8);
      }
    });
  };

  const drawPaymentMilestones = () => {
    section("6.0 Construction Payment Milestones", true);
    table(
      ["Stage", "%", "Amount (INR)"],
      paymentMilestones.map((item) => [
        item.label,
        `${item.percent}%`,
        formatCurrency((estimate.finalTotal * item.percent) / 100, 2),
      ]),
      [
        { x: 0, width: 68 },
        { x: 73, width: 20 },
        { x: 105, width: 45, align: "right" },
      ],
      { rowGap: 7, headerGap: 7, afterGap: 0 }
    );
  };

  const drawTerms = () => {
    section("7.0 TERMS, CONDITIONS & EXCLUSIONS", true);
    Object.values(staticContent.termsConditions.sections).forEach((sectionData) => {
      subSection(sectionData.title);
      sectionData.items.forEach((item) => paragraph(item, PAGE.margin + 7, 163, 8.9, 4.6));
      y += 2;
    });
  };

  const drawFooterLastPage = () => {
    ensureSpace(40);
    y = PAGE.h - 47;
    setText(9.2);
    text("Client Signature", PAGE.margin, y);
    text("Ar. Gajanan V. Shetkar", PAGE.margin + 65, y);
    y += 8;
    setText(8.5);
    text("Founder & Principal Architect | CoA: CA/2014/64577", PAGE.margin + 52, y);
    y += 12;
    setText(10, "bold");
    text("DWELLORA DESIGNS LLP", PAGE.w / 2, y, { align: "center" });
    y += 8;
    setText(8.2);
    text("ARCHITECTURE | INTERIOR | TURNKEY CONSTRUCTION", PAGE.w / 2, y, { align: "center" });
    y += 7;
    setText(7.4);
    text("Office: 601, The Stellar, Bhumkar Chowk, Wakad-411057 | M: +91 9158914222 | E: dwellorahomes@gmail.com | W: www.dwellorahomes.com", PAGE.w / 2, y, { align: "center" });
  };

  drawHeader();
  drawProjectOverview();
  drawConsultancyFees();
  drawProjectCost();
  drawScope();
  drawPackages();
  drawSpecifications();
  drawPaymentMilestones();
  drawTerms();
  drawFooterLastPage();

  return doc.output("blob");
};
/* eslint-enable no-unused-vars */


// export { calculateEstimate, generateDynamicPDF };

// const generatePDF = (data, estimate) => {
//   try {
//     if (!estimate || !estimate.final) {
//       alert("Calculation missing");
//       return;
//     }

//     const doc = new jsPDF();
//     let y = 20;

//     const col1 = 14;
//     const col2 = 90;
//     const col3 = 120;
//     const col4 = 180;

//     const checkPage = () => {
//       if (y > 270) {
//         doc.addPage();
//         y = 20;
//       }
//     };

//     const finalEstimate = estimate;
//     const constructionCost = finalEstimate.total;

//     const architectureFee = constructionCost * 0.05;
//     const pmcFee = data.pmc ? constructionCost * 0.10 : 0;
//     const liaisonFee = 150000;

//     const consultancyTotal =
//       architectureFee + pmcFee + liaisonFee;

//     const finalTotal =
//       constructionCost + consultancyTotal;

//     // ================= HEADER =================
//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(18);
//     doc.text("DWELLORA DESIGNS LLP", 105, y, { align: "center" });

//     y += 6;
//     doc.setFontSize(10);
//     doc.text(
//       "ARCHITECTURAL CONSULTANCY & TURNKEY SOLUTIONS",
//       105,
//       y,
//       { align: "center" }
//     );

//     y += 8;
//     doc.text("QUOTATION", 105, y, { align: "center" });

//     y += 12;

//     doc.setFontSize(10);
//     doc.setFont("helvetica", "normal");
//     doc.text(`Date: ${new Date().toLocaleDateString()}`, col1, y);

//     y += 12;

//     // ================= PROJECT OVERVIEW =================
//     doc.setFont("helvetica", "bold");
//     doc.text("PROJECT OVERVIEW", col1, y);

//     y += 8;

//     doc.setFont("helvetica", "normal");

//     doc.text(`Client Name: ${data.name || "-"}`, col1, y);
//     doc.text(`Plot Area: ${data.area || "-"} sq.ft`, 120, y);

//     doc.text(`Location: ${data.society || "-"}`, col1, y + 6);
//     doc.text(`Const. Area: ${data.constructionArea || "-"} sq.ft`, 120, y + 6);

//     y += 18;

//     // ================= 1.0 CONSULTANCY =================
//     doc.setFont("helvetica", "bold");
//     doc.text("1.0 ARCHITECTURAL CONSULTANCY FEES", col1, y);

//     y += 10;

//     doc.text("Service Description", col1, y);
//     doc.text("Amount (INR)", col4, y, { align: "right" });

//     y += 4;
//     doc.setDrawColor(150);
//     doc.line(col1, y, 196, y);

//     y += 8;

//     doc.setFont("helvetica", "normal");

//     doc.text("Comprehensive Architecture Design", col1, y);
//     doc.text(Math.round(architectureFee).toLocaleString("en-IN"), col4, y, { align: "right" });
//     y += 8;

//     if (pmcFee > 0) {
//       doc.text("Liaisoning Consultancy", col1, y);
//       doc.text(Math.round(pmcFee).toLocaleString("en-IN"), col4, y, { align: "right" });
//       y += 8;
//     }

//     doc.setFont("helvetica", "bold");
//     doc.text("Total Consultancy Fee", col1, y);
//     doc.text(consultancyTotal.toLocaleString("en-IN"), col4, y, { align: "right" });

//     y += 15;

//     // ================= 2.0 CONSTRUCTION =================
//     doc.setFont("helvetica", "bold");
//     doc.text("2.0 ESTIMATED PROJECT COST (RCC + FINISHING)", col1, y);

//     y += 10;

//     doc.text("Work", col1, y);
//     doc.text("Area", col2, y, { align: "right" });
//     doc.text("Rate", col3, y, { align: "right" });
//     doc.text("Total", col4, y, { align: "right" });

//     y += 4;
//     doc.line(col1, y, 196, y);

//     y += 8;

//     doc.setFont("helvetica", "normal");

//     finalEstimate.final.forEach((item) => {
//       checkPage();

//       doc.text(item.label, col1, y);
//       doc.text(item.area.toFixed(0), col2, y, { align: "right" });
//       doc.text(item.rate.toString(), col3, y, { align: "right" });
//       doc.text(item.cost.toLocaleString("en-IN"), col4, y, { align: "right" });

//       y += 8;
//     });

//     y += 2;
//     doc.line(col1, y, 196, y);

//     y += 8;

//     doc.setFont("helvetica", "bold");
//     doc.text("Total Project Value", col1, y);
//     doc.text(finalTotal.toLocaleString("en-IN"), col4, y, { align: "right" });

//     y += 15;

//     // ================= 3.0 PAYMENT =================
//     checkPage();

//     doc.setFont("helvetica", "bold");
//     doc.text("3.0 CONSTRUCTION WORK PAYMENT SCHEDULE", col1, y);

//     y += 10;

//     doc.text("Stages", col1, y);
//     doc.text("Percentage", col4, y, { align: "right" });

//     y += 4;
//     doc.line(col1, y, 196, y);

//     y += 8;

//     doc.setFont("helvetica", "normal");

//     [
//       ["Advance", "30%"],
//       ["After Design Finalised", "30%"],
//       ["After PMRDA Sanction", "30%"],
//       ["After Detail Working Drawings", "10%"],
//       ["Total", "100%"],
//     ].forEach((row) => {
//       doc.text(row[0], col1, y);
//       doc.text(row[1], col4, y, { align: "right" });
//       y += 8;
//     });

//     y += 15;

//     // ================= 4.0 SCOPE =================
//     checkPage();

//     doc.setFont("helvetica", "bold");
//     doc.text("4.0 DETAILED SCOPE OF SERVICES", col1, y);

//     y += 8;

//     doc.setFont("helvetica", "normal");

//     [
//       "Concept Design, Layout Planning",
//       "Floor Plans & Elevations",
//       "3D Views & Façade Design",
//       "Working Drawings",
//       "Electrical & Plumbing Layout"
//     ].forEach((t) => {
//       doc.text(`• ${t}`, col1, y);
//       y += 6;
//     });

//     y += 15;

//     // ================= 5.0 SPEC =================
//     checkPage();

//     doc.setFont("helvetica", "bold");
//     doc.text("5.0 SPECIFICATIONS FOR CONSTRUCTION", col1, y);

//     y += 8;

//     doc.setFont("helvetica", "normal");

//     [
//       "RCC framed structure (M-20 & F-500)",
//       "TMT steel bars (top brands)",
//       "Internal POP plaster",
//       "External double coat plaster",
//       "Red brick walls",
//       "Granite staircase",
//       "MS railing",
//       "Granite window sills"
//     ].forEach((t) => {
//       doc.text(`• ${t}`, col1, y);
//       y += 6;
//     });

//     // ================= FOOTER =================
//     doc.setFontSize(9);
//     doc.text(
//       "Dwellora Designs LLP | Pune | +91 9158914222 | www.dwellorahomes.com",
//       105,
//       285,
//       { align: "center" }
//     );

//     doc.save("Dwellora_Quotation.pdf");

//   } catch (err) {
//     console.log(err);
//     alert("PDF generation failed");
//   }
// };


//   const nextStep = () => {
//     if (step === 1) {
//       if (!data.openPlot && !data.nonApprovedProperty) {
//         alert("Please select either 'Open Plot' or 'NA Approved Layout'");
//         return;
//       }

//       if (data.nonApprovedProperty) {
//         // If NA Approved Layout is selected, require society, plot, and building type
//         if (!data.society || !data.plot || !data.buildingType) {
//           alert(
//             "Please enter society name, plot number, and select building type",
//           );
//           return;
//         }
//       } else if (data.openPlot) {
//         // If open plot, validate open plot details
//         if (data.areaInputType === "lengthWidth") {
//           if (!data.openPlotLength || !data.openPlotWidth) {
//             alert("Please enter length and width for open plot");
//             return;
//           }
//         } else if (data.areaInputType === "area") {
//           if (!data.openPlotArea) {
//             alert("Please enter area for open plot");
//             return;
//           }
//         } else {
//           alert("Please select how you want to input plot details");
//           return;
//         }
//       }
//     }

//     // if (step === 2) {
//     //   if (!data.length || !data.width) {
//     //     alert("Please enter plot length and width");
//     //     return;
//     //   }
//     // }

//     if(step===2){

// if(data.areaInputType==="lengthWidth"){
// if(!data.length || !data.width){
// alert("Please enter plot length and width")
// return
// }
// }

// if(data.areaInputType==="area"){
// if(!data.openPlotArea){
// alert("Please enter plot area")
// return
// }
// }

// }

//     if (step === 3) {
//       if (!data.architecture) {
//         alert("Please select Architectural Design service to continue.");
//         return;
//       }
//     }

//     if (step === 4) {
//       if (
//         !data.liaison ||
//         !data.construction ||
//         !data.interior 
//         // !data.building
//       ) {
//         alert("Please select all required services");
//         return;
//       }
//     }

//     // if (step === 6) {
//     //   if (!data.name || !data.mobile || !data.email) {
//     //     alert("Please fill contact details");
//     //     return;
//     //   }
//     // }

//     // If open plot is selected, skip step 2 and go to step 3
//     if (step === 1 && data.openPlot) {
//       setStep(3);
//     } else {
//       setStep((prev) => prev + 1);
//     }

//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };

const nextStep = () => {
  const needsPackageStep = requiresPackageSelection(data.construction);
  const cityValue = data.city?.trim();
  let newErrors = {};

  // STEP 1 LOGIC 
  if (step === 1) {
    if (!data.openPlot && !data.nonApprovedProperty) {
      newErrors.propertyType = true;
    }

    if (data.openPlot) {
      if (!data.citySelection) {
        newErrors.citySelection = true;
      } else if (data.citySelection === "Other" && !cityValue) {
        newErrors.city = true;
      }

      if (!data.areaInputType) {
        newErrors.areaInputType = true;
      }

      if (data.areaInputType === "lengthWidth") {
        if (!String(data.openPlotLength || "").trim()) newErrors.openPlotLength = true;
        if (!String(data.openPlotWidth || "").trim()) newErrors.openPlotWidth = true;
      }

      if (data.areaInputType === "area" && !String(data.openPlotArea || "").trim()) {
        newErrors.openPlotArea = true;
      }
    }

    if (data.nonApprovedProperty) {
      if (!data.citySelection) {
        newErrors.citySelection = true;
      } else if (data.citySelection === "Other" && !cityValue) {
        newErrors.city = true;
      }

      if (!String(data.society || "").trim()) newErrors.society = true;
      if (!String(data.plot || "").trim()) newErrors.plot = true;
    }

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setStep(data.openPlot ? 3 : 2);
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }

  if (step === 2) {
    if (!data.areaInputType) {
      newErrors.areaInputType = true;
    }

    if (data.areaInputType === "lengthWidth") {
      if (!String(data.unit || "").trim()) newErrors.unit = true;
      if (!String(data.length || "").trim()) newErrors.length = true;
      if (!String(data.width || "").trim()) newErrors.width = true;
    }

    if (data.areaInputType === "area" && !String(data.openPlotArea || "").trim()) {
      newErrors.openPlotArea = true;
    }

    if (!String(data.authority || "").trim()) newErrors.authority = true;
    if (!String(data.road || "").trim()) newErrors.road = true;

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setStep(3);
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }

  if (step === 5) {
    if (!data.buildingType) newErrors.buildingType = true;
    if (!data.building) newErrors.building = true;

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setStep(needsPackageStep ? 6 : 7);
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }

  if (step === 6) {
    if (!needsPackageStep) {
      setErrors({});
      setStep(7);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (needsPackageStep && !data.packageType) {
      setErrors({ packageType: true });
      return;
    }

    setErrors({});
    setStep(7);
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }

  if (step === 4) {
    if (data.pmc && !data.liaison) newErrors.liaison = true;
    if (!data.construction) newErrors.construction = true;
    if (!data.interior) newErrors.interior = true;

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }
  }

  setErrors({});

  setStep((prev) => prev + 1);

  window.scrollTo({ top: 0, behavior: "smooth" });
};

const ESTIMATE_SAVE_API_URL =
  process.env.REACT_APP_ESTIMATE_SAVE_API_URL || "https://dwellorahomes.com/save_estimate.php";
const QUOTATION_UPLOAD_API_URL =
  process.env.REACT_APP_QUOTATION_UPLOAD_API_URL || "https://dwellorahomes.com/upload.php";

const normalizeDataForEstimate = (formData) => ({
  ...formData,
  buildingType: normalizeBuildingTypeValue(formData.buildingType),

  construction:
    formData.construction === "Grey Structure Only" ? "grey" :
    formData.construction === "Complete Construction" ? "complete" :
    formData.construction,

  packageType:
    formData.packageType === "Basic" ? "basic" :
    formData.packageType === "Standard" ? "standard" :
    formData.packageType === "Premium" ? "premium" :
    formData.packageType,
});

const normalizeWhatsAppNumber = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "");
  if (digits.length === 10) return `91${digits}`;
  return digits;
};

const buildOwnerEmailAddress = (quoteData = {}) => {
  const parts = [quoteData.society, quoteData.plot ? `Plot No. ${quoteData.plot}` : ""]
    .map((value) => String(value || "").trim())
    .filter(Boolean);

  return parts.join(", ");
};

const uploadQuotationPDF = async (pdfBlob, quoteData = {}) => {
  const safeClientName = String(quoteData.name || "client")
    .trim()
    .replace(/[^a-z0-9]/gi, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase() || "client";

  const formData = new FormData();
  formData.append("pdf", pdfBlob, `Dwellora-Quotation-${safeClientName}.pdf`);
  formData.append("client_name", String(quoteData.name || "").trim());
  formData.append("client_mobile", String(quoteData.mobile || "").trim());
  formData.append("client_email", String(quoteData.email || "").trim());
  formData.append("client_address", buildOwnerEmailAddress(quoteData));

  let response;
  try {
    response = await fetch(QUOTATION_UPLOAD_API_URL, {
      method: "POST",
      body: formData,
    });
  } catch (err) {
    throw new Error(
      `PDF upload API connect nahi ho rahi: ${QUOTATION_UPLOAD_API_URL}. upload.php server par deploy hai aur CORS enabled hai ya nahi check karein.`
    );
  }

  const result = await response.json().catch(() => ({}));

  if (!response.ok || result.status !== "success" || !result.url) {
    throw new Error(result.message || "PDF upload failed");
  }

  return result;
};

const buildWhatsAppMessage = (quoteData, pdfUrl) => `
Dwellora Homes Quotation

Name: ${quoteData.name}
Mobile: ${quoteData.mobile}

Plot Area: ${quoteData.area} sq.ft
Construction Area: ${quoteData.constructionArea} sq.ft
FSI: ${quoteData.fsi}

Building: ${getDisplayStructure(quoteData.building)}
Building Type: ${getDisplayBuildingType(quoteData.buildingType)}

Services:
- Construction: ${quoteData.construction || "-"}
- Interior: ${quoteData.interior || "-"}
- Liaison: ${quoteData.liaison || "-"}

Quotation PDF:
${pdfUrl}


`;

const getWhatsAppUrl = (phone, message) => {
  const normalizedPhone = normalizeWhatsAppNumber(phone);
  if (!normalizedPhone) return "";

  return `https://wa.me/${normalizedPhone}?text=${encodeURIComponent(message)}`;
};

const sendWhatsApp = (quoteData, pdfUrl) => {
  const message = buildWhatsAppMessage(quoteData, pdfUrl);
  const clientUrl = getWhatsAppUrl(quoteData.mobile, message);

  if (!clientUrl) {
    return Promise.resolve();
  }

  return Swal.fire({
    title: "Quotation ready",
    html: `
      <div style="display:flex; flex-direction:column; gap:12px; margin-top:8px;">
        <p style="margin:0 0 4px; color:#555;">Your quotation PDF is ready to share.</p>
        <a id="open-whatsapp-link" href="${clientUrl}" target="_blank" rel="noopener noreferrer"
          style="background:#25D366; color:#fff; padding:12px 16px; border-radius:6px; text-decoration:none; font-weight:600;">
          Open WhatsApp
        </a>
      </div>
    `,
    icon: "success",
    confirmButtonText: "Done",
    confirmButtonColor: "#4d2c5e",
    allowOutsideClick: false,
    didOpen: () => {
      const openWhatsAppLink = Swal.getPopup()?.querySelector("#open-whatsapp-link");

      openWhatsAppLink?.addEventListener("click", (event) => {
        event.preventDefault();

        if (clientUrl) {
          window.open(clientUrl, "_blank", "noopener,noreferrer");
        }

        Swal.close();
        resetEstimateForm();
      });
    },
  });
};

const resetEstimateForm = () => {
  setData({
    society: "",
    city: "",
    citySelection: "",
    plot: "",
    unit: "",
    length: "",
    width: "",
    authority: "",
    road: "",
    area: 0,
    fsi: "",
    constructionArea: 0,
    architecture: "",
    pmc: false,
    liaison: "",
    construction: "",
    interior: "",
    execution: "",
    building: "",
    buildingType: "",
    customBuildingType: "",
    buildingTypeStep5: "",
    customCategory: "",
    customSubType: "",
    floorsCount: "",
    floorsData: [],
    parking: "",
    cars: "",
    floor1: "",
    floor2: "",
    floor3: "",
    ground: "",
    customRequirement: "",
    rooms: 2,
    other: "",
    name: "",
    mobile: "",
    email: "",
    openPlot: false,
    nonApprovedProperty: false,
    areaInputType: "",
    openPlotLength: "",
    openPlotWidth: "",
    openPlotArea: "",
  });

  setStep(1);
  setShowSummary(false);

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const submit = async () => {
  if (submitInFlightRef.current) return;

  const stopSubmitting = () => {
    submitInFlightRef.current = false;
    setIsSubmitting(false);
    setSubmitStatus("");
  };

  submitInFlightRef.current = true;
  setShowSummary(false);
  setIsSubmitting(true);
  setSubmitStatus("Generating PDF...");
  await waitForNextPaint();

  try {
    const normalized = normalizeDataForEstimate(data);
    const estimate = calculateEstimate(normalized);
    const pdfBlob = await generatePerfectPDF(normalized, estimate);

    if (!pdfBlob) return;

    setSubmitStatus("Saving your details...");

    let res;
    try {
      res = await fetch(ESTIMATE_SAVE_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...normalized,
          length: normalized.openPlot ? normalized.openPlotLength : normalized.length,
          width: normalized.openPlot ? normalized.openPlotWidth : normalized.width,
          area: normalized.area || normalized.openPlotArea,
          constructionArea: normalized.constructionArea,
        }),
      });
    } catch (err) {
      throw new Error(
        `Estimate save API connect nahi ho rahi: ${ESTIMATE_SAVE_API_URL}. Localhost se test kar rahe hain to save_estimate.php me CORS/OPTIONS headers add karein.`
      );
    }

    const result = await res.json().catch(() => ({}));

    if (result.status !== "success") {
      alert(result.message || "Unable to submit your requirement");
      return;
    }

    setSubmitStatus("Uploading PDF...");
    const uploadResult = await uploadQuotationPDF(pdfBlob, normalized);
    const pdfUrl = uploadResult.url;
    setSubmitStatus("Opening WhatsApp...");
    await waitForNextPaint();

    stopSubmitting();
    await Swal.fire({
      title: "Submitted!",
      html: "<b>Thank you! Your requirement has been submitted successfully</b>",
      icon: "success",
      confirmButtonText: "Continue",
      confirmButtonColor: "#4d2c5e",
      backdrop: `rgba(0,0,0,0.7)`,
    });

    if (String(normalized.mobile || "").trim()) {
      await sendWhatsApp(normalized, pdfUrl);
    }

    resetEstimateForm();
  } catch (err) {
    console.log("API error", err);
    alert(err.message || "Server error");
  } finally {
    stopSubmitting();
  }
};

  // Handle submit - show summary on mobile, submit on desktop

  const handleSubmit = () => {
  if (isSubmitting) return;
  if (!validateStep6()) return;

  if (isMobile) {
    setShowSummary(true);
  } else {
    submit();
  }
};

/*
  const phone = data.mobile;

  const message = `
🏡 Dwelloara Homes Estimate

👤 Name: ${data.name}
📞 Mobile: ${data.mobile}

📐 Plot Area: ${data.area} sq.ft
🏗 Construction Area: ${data.constructionArea} sq.ft
📊 FSI: ${data.fsi}

🏢 Building: ${data.building || "-"}

🛠 Services:
- Construction: ${data.construction || "-"}
- Interior: ${data.interior || "-"}
- Liaison: ${data.liaison || "-"}


`;

  const url = `https://wa.me/91${phone}?text=${encodeURIComponent(message)}`;

  window.open(url, "_blank");
};

*/
const [errors, setErrors] = useState({});
const hasError = (fieldName) => Boolean(errors[fieldName]);
const hasAnyError = (fieldNames) => fieldNames.some((fieldName) => Boolean(errors[fieldName]));

useEffect(() => {
  if (step === 6 && !requiresPackageSelection(data.construction)) {
    setStep(5);
  }
}, [step, data.construction]);

const validateStep6 = () => {
  let newErrors = {};
  const needsPackageStep = requiresPackageSelection(data.construction);
  const mobileValue = String(data.mobile || "").trim();
  const emailValue = String(data.email || "").trim();

  if (needsPackageStep && !data.packageType) {
    newErrors.packageType = "Please select a package before submitting";
  }

  // Name
  if (!data.name || data.name.trim().length < 2) {
    newErrors.name = "Please enter valid name";
  }

  if (!mobileValue && !emailValue) {
    newErrors.mobile = "Please enter mobile number or email";
    newErrors.email = "Please enter mobile number or email";
  }

  // Mobile
  if (mobileValue && !/^[6-9]\d{9}$/.test(mobileValue)) {
    newErrors.mobile = "Enter valid 10 digit mobile number";
  }

  // Email 
  if (emailValue && !/^\S+@\S+\.\S+$/.test(emailValue)) {
    newErrors.email = "Enter valid email";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};

const handlePackageSelect = (packageType) => {
  if (!requiresPackageSelection(data.construction)) return;

  setData((prev) => ({
    ...prev,
    packageType,
  }));
  clearFieldError("packageType");
  setStep(7);
  window.scrollTo({ top: 0, behavior: "smooth" });
};

// const config = percentConfig[data.buildingType];

// if (!config) {
//   console.log("Missing config for:", data.buildingType);
//   return null;
// }

// const percentConfig = {
//   RowHouse: {
//     plinth: 0.55,
//     parking: 0.60,
//     floor1: 0.60,
//     floor2: 0.60,
//     floor3Full: 0.60,
//     floor3Half: 0.30,
//   },

//   TwinBungalow: {
//     plinth: 0.52,
//     parking: 0.60,
//     floor1: 0.60,
//     floor2: 0.60,
//     floor3Full: 0.60,
//     floor3Half: 0.30,
//   },

//   IndependentBungalow: {
//     plinth: 0.50,
//     parking: 0.55,
//     floor1: 0.55,
//     floor2: 0.55,
//     floor3Full: 0.55,
//     floor3Half: 0.28,
//   },

//   ResidentialApartment: {
//     plinth: 0.50,
//     parking: 0.55,
//     floor1: 0.55,
//     floor2: 0.55,
//     floor3Full: 0.55,
//     floor3Half: 0.28,
//   },

//   StudioApartment: {
//     plinth: 0.50,
//     parking: 0.55,
//     floor1: 0.55,
//     floor2: 0.55,
//     floor3Full: 0.55,
//     floor3Half: 0.28,
//   },

//   MixedUse: {
//     plinth: 0.50,
//     parking: 0.55,
//     floor1: 0.55,
//     floor2: 0.55,
//     floor3Full: 0.55,
//     floor3Half: 0.28,
//   },

//   Commercial: {
//     plinth: 0.50,
//     parking: 0.55,
//     floor1: 0.55,
//     floor2: 0.55,
//     floor3Full: 0.55,
//     floor3Half: 0.28,
//   }
// };

// const addonConfig = {
//   TwinBungalow: 0.60,
//   IndependentBungalow: 0.55,
//   ResidentialApartment: 0.55,
//   StudioApartment: 0.55,
//   MixedUse: 0.55,
//   Commercial: 0.55,
//   RowHouse: 0.60,
// };

// const rateConfig = {
//   grey: {
//     plinth: 900,
//     parking: 900,
//     floor: 1250,
//     terrace: 1250,
//   },
//   complete: {
//     plinth: 900,
//     parking: 900,
//     floor: 1850,
//     terrace: 1850,
//   },
// };

// const packageRate = {
//   basic: 1600,
//   standard: 1800,
//   premium: 2000
// };

// const calculateSheetEstimate = () => {
// const baseArea = parseFloat(data.area || data.openPlotArea);
//   if (!baseArea) return null;

// const config = percentConfig[data.buildingType || "IndependentBungalow"];
// const rates = rateConfig[data.construction || "grey"];

//   if (!config || !rates) return null;

//   let rows = [];

//   // 🔴 P+3
//   if (data.building === "p3") {
//     rows = [
//       { label: "Plinth", percent: config.plinth, type: "plinth" },

//       { label: "Parking / Stilt", percent: config.parking, type: "parking" },

//       { label: "First Floor", percent: config.floor1, type: "floor" },

//       { label: "Second Floor", percent: config.floor2, type: "floor" },

//       {
//         label: "Third Floor",
//         percent:
//           data.thirdFloorType === "half"
//             ? config.floor3Half
//             : config.floor3Full,
//         type:
//           data.thirdFloorType === "half"
//             ? "terrace"
//             : "floor",
//       },
//     ];
//   }

//   // 🟡 G+2
//   else if (data.building === "g2") {
//     rows = [
//       { label: "Plinth", percent: config.plinth, type: "plinth" },

//       // ✅ FIX: Parking optional (only if needed later)
//       { label: "Parking / Stilt", percent: config.parking, type: "parking" },

//       { label: "Ground Floor", percent: config.floor1, type: "floor" },

//       { label: "First Floor", percent: config.floor2, type: "floor" },

//       {
//         label: "Second Floor",
//         percent:
//           data.secondFloorType === "half"
//             ? config.floor3Half
//             : config.floor3Full,
//         type:
//           data.secondFloorType === "half"
//             ? "terrace"
//             : "floor",
//       },
//     ];
//   }

//   //  CUSTOM (FINAL FIXED LOGIC)
//   else if (data.building === "custom") {
//     rows = [];

//     // ✅ ALWAYS PLINTH
//     rows.push({
//       label: "Plinth",
//       percent: config.plinth,
//       type: "plinth",
//     });

//     // ✅ PARKING OR GROUND (NOT BOTH)
//     if (data.customParking === "yes") {
//       rows.push({
//         label: "Parking / Stilt",
//         percent: config.parking,
//         type: "parking",
//       });
//     } else {
//       rows.push({
//         label: "Ground Floor",
//         percent: config.floor1,
//         type: "floor",
//       });
//     }

//     // ✅ FLOORS LOOP
//     const count = data.floorsData.length;

//     for (let i = 0; i < count; i++) {
//       const isLast = i === count - 1;

//       let percent = config.floor1;
//       let type = "floor";

//       let label = `${i + 1} Floor`;

//       // ✅ LAST FLOOR LOGIC
//       if (isLast) {
//         percent =
//           data[`floor${i + 1}Type`] === "half"
//             ? config.floor3Half
//             : config.floor3Full;

//         type =
//           data[`floor${i + 1}Type`] === "half"
//             ? "terrace"
//             : "floor";
//       }

//       rows.push({ label, percent, type });
//     }
//   }

//   // ✅ FINAL CALCULATION
//   const final = rows.map((item) => {
//     const area = baseArea * item.percent;

//     let rate = 0;

//     if (item.type === "plinth") rate = rates.plinth;
//     else if (item.type === "parking") rate = rates.parking;
//     else if (item.type === "terrace") rate = rates.terrace;
//     else rate = rates.floor;

//     return {
//       ...item,
//       area,
//       rate,
//       cost: area * rate,
//     };
//   });

//   // =========================
// // PACKAGE ADD-ON
// // =========================

// let packageCost = 0;

// if (data.construction === "grey" && data.packageType) {
//   const totalArea = final.reduce((sum, i) => sum + i.area, 0);
//   const pkgRate = packageRate[data.packageType];

//   packageCost = totalArea * pkgRate;
// }

//   // ADDON CALCULATION (FINAL FIX)
// const addonPercent = addonConfig[data.buildingType];

// if (addonPercent && baseArea) {
//   const addonArea = baseArea * addonPercent;

//   const addonRate = rates.plinth; // 900

//   final.push({
//     label: "Parapet + Terrace WP + Staircase + Water Tank",
//     area: addonArea,
//     rate: addonRate,
//     cost: addonArea * addonRate,
//   });
// }

//   // const total = final.reduce((sum, i) => sum + i.cost, 0);
  
// const baseTotal = final.reduce((sum, i) => sum + i.cost, 0);

// if (data.construction === "complete") {
//   packageCost = 0;
// }

// const total = baseTotal + packageCost;

//   return { final, total, packageCost };
// };

const categoryData = [  
  {
    icon: structure,
    title: "Structure & Foundation",
    basic: "RCC structure as per structural consultant design + TMT steel bars",
    standard: "Same as Basic",
    premium: "Same as Basic"
  },
  {
    icon: wall,
    title: "Wall Material",
    basic: "Red brick walls",
    standard: "AAC Blocks / C4X Bricks",
    premium: "Same as Standard"
  },
  {
    icon: plaster,
    title: "Plastering",
    basic: "Direct POP finish (internal) + basic external plaster",
    standard: "Double coat plaster + POP finish (internal)",
    premium: "Premium double coat plaster + high-quality POP finish"
  },
  {
    icon: windowImg,
    title: "Windows",
    basic: "Basic aluminum windows",
    standard: "Aluminum sliding (powder-coated)",
    premium: "Premium UPVC / large panels"
  },
  {
    icon: door,
    title: "Main Door",
    basic: "Basic flush door",
    standard: "Teak wood frame + flush door",
    premium: "Designer teak door"
  },
  {
    icon: door,
    title: "Internal Doors",
    basic: "Basic flush doors",
    standard: "Standard flush doors",
    premium: "Premium laminated doors"
  },
  {
    icon: kitchen,
    title: "Kitchen",
    basic: "Basic platform",
    standard: "Granite platform + dado",
    premium: "Quartz / designer kitchen"
  },
  {
    icon: bathroom,
    title: "Bathroom",
    basic: "Basic fittings",
    standard: "Jaquar standard fittings",
    premium: "Premium Jaquar fittings"
  },
  {
    icon: electrical,
    title: "Electrical",
    basic: "Standard wiring",
    standard: "Legrand + Polycab wiring",
    premium: "Modular + smart provision"
  },
  {
    icon: paint,
    title: "Paint",
    basic: "Putty + basic paint",
    standard: "Asian Paints (standard finish)",
    premium: "Asian Paints Royale / premium finish"
  },
  {
    icon: staircase,
    title: "Staircase",
    basic: "Cement finish",
    standard: "Granite finish",
    premium: "Granite + glass railing"
  },
  {
    icon: flooring,
    title: "Flooring",
    basic: "Basic tiles",
    standard: "Vitrified tiles",
    premium: "Large format premium tiles"
  },
  {
    icon: plumbing,
    title: "Plumbing",
    basic: "Standard pipes",
    standard: "Finolex / UPVC pipes",
    premium: "Same as Standard"
  },
  {
    icon: height,
    title: "Ceiling Height",
    basic: "9.5 ft height",
    standard: "10 ft height",
    premium: "10–11 ft premium height"
  },
  {
    icon: waterproof,
    title: "Waterproofing",
    basic: "Integral waterproofing",
    standard: "Acrylic coating system",
    premium: "Advanced chemical / PU waterproofing"
  },
  {
    icon: finish,
    title: "Overall Finish",
    basic: "Budget-friendly",
    standard: "Modern & balanced",
    premium: "Premium luxury finish"
  }
];
  return (

<>

    <div className="ce-estimator">
      <div className="ce-progress-wrapper">
        <div className="ce-progress-text">Step {step} of 7</div>

        <div className="ce-progress-bar">
          <div
            className="ce-progress-fill"
            // style={{width:`${(step/7)*100}%`}}
            style={{ width: `${(step / 7) * 100}%` }}
          ></div>
        </div>
      </div>

{/* STEP 6 FULL WIDTH */}
{step === 6 && data.construction === "complete" && (
  <div className="pkg-wrapper">
   
    <div className="pkg-grid">

      {/* CATEGORY */}
      {/* CATEGORY */}
<div className="pkg-card category">
  <div className="pkg-top">
    <h5>Category</h5>
  </div>

  <div className="pkg-body">
    {categoryData.map((item, i) => (
     <div
  className={`pkg-row ${hoverIndex === i ? "active-row" : ""}`}
  key={i}
  onMouseEnter={() => setHoverIndex(i)}
  onMouseLeave={() => setHoverIndex(null)}
>
        <p>
          <img src={item.icon} alt="" className="icon-img" />
          {item.title}
        </p>
      </div>
    ))}
  </div>

  {/*  BACK BUTTON HERE */}
  <div className="pkg-back-btn">
   <button onClick={() => setStep(prev => prev - 1)}> ← Back</button>
  </div>
</div>

      {/* BASIC */}
      <div className={`pkg-card ${data.packageType === "basic" ? "active" : ""}`}>
        <div className="pkg-top">
          <div className="pkg-pill">Basic</div>
          <h2>₹1600 / sqft</h2>
        </div>

        <div className="pkg-body">
          {categoryData.map((item, i) => (
           <div
  className={`pkg-row ${hoverIndex === i ? "active-row" : ""}`}
  key={i}
  onMouseEnter={() => setHoverIndex(i)}
  onMouseLeave={() => setHoverIndex(null)}
>
              <p>{item.basic}</p>
            </div>
          ))}
        </div>

        <button
          onClick={() => {
            handlePackageSelect("basic");
          }}
        >
          Select Package ₹1600 / sqft
        </button>

       
      </div>

      {/* STANDARD */}
      <div className={`pkg-card ${data.packageType === "standard" ? "active" : ""}`}>
        <div className="pkg-top">
          <div className="pkg-pill">Standard</div>
          <h2>₹1800 / sqft</h2>
        </div>

        <div className="pkg-body">
          {categoryData.map((item, i) => (
           <div
  className={`pkg-row ${hoverIndex === i ? "active-row" : ""}`}
  key={i}
  onMouseEnter={() => setHoverIndex(i)}
  onMouseLeave={() => setHoverIndex(null)}
>
              <p>{item.standard}</p>
            </div>
          ))}
        </div>

        <button
          onClick={() => {
            handlePackageSelect("standard");
          }}
        >
          Select Package ₹1800 / sqft
        </button>

       
      </div>

      {/* PREMIUM */}
      <div className={`pkg-card ${data.packageType === "premium" ? "active" : ""}`}>
        <div className="pkg-top">
          <div className="pkg-pill premium">Premium</div>
          <h2>₹2000 / sqft</h2>
        </div>

        <div className="pkg-body">
          {categoryData.map((item, i) => (
           <div
  className={`pkg-row ${hoverIndex === i ? "active-row" : ""}`}
  key={i}
  onMouseEnter={() => setHoverIndex(i)}
  onMouseLeave={() => setHoverIndex(null)}
>

              <p>{item.premium}</p>
            </div>
          ))}
        </div>


        <button
          onClick={() => {
            handlePackageSelect("premium");
          }}
        >
          Select Package ₹2000 / sqft
        </button>

      
      </div>

    </div>



  </div>
)}

      <div className="ce-grid">
        <div>
          {/* STEP 1 */}

          {step === 1 && (
            <div className="ce-card">
              <h3>Property Type </h3>
              <p className="para"> Select your property type to help us understand your project requirements</p>

              {/* Open Plot and Non-Approved Property Radio Buttons */}

              <div className={`ce-radio-group ${hasError("propertyType") ? "ce-group-error" : ""}`}>
                <label className="ce-radio-label">
                  <input
                    type="radio"
                    name="propertyType"
                    value="openPlot"
                    checked={data.openPlot}
                    onChange={() => {
                      setData({
                        ...data,
                        openPlot: true,
                        nonApprovedProperty: false,
                        areaInputType: "",
                      });
                      clearFieldError("propertyType", "citySelection", "city", "areaInputType", "openPlotLength", "openPlotWidth", "openPlotArea", "society", "plot");
                    }}
                  />
                  <span className="ce-radio-custom"></span>
                  <div>
                    <strong>Open Plot</strong>
                    <p>A plot without layout approval or subdivision</p>
                  </div>
                </label>

                <label className="ce-radio-label">
                  <input
                    type="radio"
                    name="propertyType"
                    value="nonApproved"
                    checked={data.nonApprovedProperty}
                    onChange={() => {
                      setData({
                        ...data,
                        nonApprovedProperty: true,
                        openPlot: false,
                        areaInputType: "",
                      });
                      clearFieldError("propertyType", "citySelection", "city", "areaInputType", "openPlotLength", "openPlotWidth", "openPlotArea", "society", "plot");
                    }}
                  />
                  <span className="ce-radio-custom"></span>
                  <div>
                    <strong>NA Approved Layout</strong>
                    <p>Plot within an approved non-agricultural layout</p>
                  </div>
                </label>
              </div>

              {/* Open Plot Input Fields - Show when Open Plot is selected */}

              {data.openPlot && (
                <div className={`ce-open-plot-section ${hasAnyError(["citySelection", "city", "areaInputType", "openPlotLength", "openPlotWidth", "openPlotArea"]) ? "ce-section-error" : ""}`}>
                  <div className={`ce-field ce-float ${hasError("citySelection") ? "ce-field-error" : ""}`}>
                    <select
                      name="citySelection"
                      value={data.citySelection}
                      onChange={handle}
                      required
                    >
                      <option value=""></option>
                      {CITY_OPTIONS.map((city) => (
                        <option key={city} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                    <label>Select Your City</label>
                  </div>

                  {data.citySelection === "Other" && (
                    <div className={`ce-field ${hasError("city") ? "ce-field-error" : ""}`}>
                      <input
                        type="text"
                        name="city"
                        value={data.city}
                        onChange={handle}
                        placeholder=" "
                        required
                      />
                      <label>Enter City Name</label>
                    </div>
                  )}

                  <h4>Open Plot Details</h4>

                  <div className={`ce-input-type-selector ${hasError("areaInputType") ? "ce-group-error" : ""}`}>
                    <label className="ce-input-type-radio">
                      <input
                        type="radio"
                        name="areaInputType"
                        value="lengthWidth"
                        checked={data.areaInputType === "lengthWidth"}
                        onChange={(e) => {
                          setData({ ...data, areaInputType: e.target.value });
                          clearFieldError("areaInputType", "openPlotLength", "openPlotWidth", "openPlotArea");
                        }}
                      />
                      <span className="ce-radio-dot"></span>I know Length and
                      Width
                    </label>

                    <label className="ce-input-type-radio">
                      <input
                        type="radio"
                        name="areaInputType"
                        value="area"
                        checked={data.areaInputType === "area"}
                        onChange={(e) => {
                          setData({ ...data, areaInputType: e.target.value });
                          clearFieldError("areaInputType", "openPlotLength", "openPlotWidth", "openPlotArea");
                        }}
                      />
                      <span className="ce-radio-dot"></span>I know Total Area
                    </label>
                  </div>

                  {data.areaInputType === "lengthWidth" && (
                    <>
                      <div className="ce-field ce-float">
                        <select
                          name="openPlotLengthWidthUnit"
                          value={data.openPlotLengthWidthUnit}
                          onChange={handle}
                          required
                        >
                          <option value="Feet">Feet</option>
                          <option value="Meter">Meter</option>
                        </select>
                        <label>Unit</label>
                      </div>

                      <div className="ce-input-row">
                        <div className={`ce-field ce-field-half ce-no-spinner ${hasError("openPlotLength") ? "ce-field-error" : ""}`}>
                          <input
                            type="number"
                            name="openPlotLength"
                            value={data.openPlotLength}
                            onChange={handle}
                            placeholder=""
                            min="0"
                            step="0.01"
                          />
                          <label>Length ({data.openPlotLengthWidthUnit})</label>
                        </div>

                        <div className={`ce-field ce-field-half ce-no-spinner ${hasError("openPlotWidth") ? "ce-field-error" : ""}`}>
                          <input
                            type="number"
                            name="openPlotWidth"
                            value={data.openPlotWidth}
                            onChange={handle}
                            placeholder=""
                            min="0"
                            step="0.01"
                          />
                          <label>Width ({data.openPlotLengthWidthUnit})</label>
                        </div>
                      </div>
                    </>
                  )}

                  {data.areaInputType === "area" && (
                    <>
                      <div className="ce-field ce-float">
                        <select
                          name="openPlotAreaUnit"
                          value={data.openPlotAreaUnit}
                          onChange={handle}
                          required
                        >
                          <option value="sq.ft">sq.ft</option>
                          <option value="sq.meter">sq.meter</option>
                        </select>
                        <label>Unit</label>
                      </div>

                      <div className={`ce-field ce-no-spinner ${hasError("openPlotArea") ? "ce-field-error" : ""}`}>
                        <input
                          type="number"
                          name="openPlotArea"
                          value={data.openPlotArea}
                          onChange={handle}
                          placeholder=""
                          min="0"
                          step="0.01"
                        />
                        {/* <span 
className="ce-input-addon ce-input-addon-clickable"
onClick={() => setData({...data, openPlotAreaUnit: data.openPlotAreaUnit === "sq.ft" ? "sq.meter" : "sq.ft"})}
title="Click to toggle between sq.ft and sq.meter"
>
{data.openPlotAreaUnit === "sq.ft" ? "sq.ft" : "sq.m"}
</span> */}
                        {/* <label>Total Area ({data.openPlotAreaUnit})</label> */}
                        <label>Total Area ({data.openPlotAreaUnit})</label>
                      </div>
                    </>
                  )}
                </div>
              )}

              {data.nonApprovedProperty && (
                <>
                  <div className={`ce-field ce-float ${hasError("citySelection") ? "ce-field-error" : ""}`}>
                    <select
                      name="citySelection"
                      value={data.citySelection}
                      onChange={handle}
                      required
                    >
                      <option value=""></option>
                      {CITY_OPTIONS.map((city) => (
                        <option key={city} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                    <label>Select Your City</label>
                  </div>

                  {data.citySelection === "Other" && (
                    <div className={`ce-field ${hasError("city") ? "ce-field-error" : ""}`}>
                      <input
                        type="text"
                        name="city"
                        value={data.city}
                        onChange={handle}
                        placeholder=" "
                        required
                      />
                      <label>Enter City Name</label>
                    </div>
                  )}

                  {/* Society */}

                  <div className={`ce-field ${hasError("society") ? "ce-field-error" : ""}`}>
                    <input
                      type="text"
                      name="society"
                      value={data.society}
                      onChange={handle}
                      placeholder=" "
                      required
                    />

                    <label>Enter Society Name</label>
                  </div>

                  {/* Plot Number (same floating input) */}

                  <div className={`ce-field ${hasError("plot") ? "ce-field-error" : ""}`}>
                    <input
                      type="text"
                      name="plot"
                      value={data.plot}
                      onChange={handle}
                      placeholder=" "
                      required
                    />

                    <label>Enter Plot Number</label>
                  </div>

                  {/* Building Type (dropdown floating) */}

                  {/* <div className="ce-field ce-float">
                    <select
                      name="buildingType"
                      value={data.buildingType}
                      onChange={handle}
                      required
                    >
                      <option value=""></option>
                      <option value="RowHouse">Row House</option>
                      <option value="TwinBungalow">Twin Bungalow</option>
                      <option value="IndependentBungalow">
                        Independent Bungalow
                      </option>
                      <option value="ResidentalApartment">
                        Residential Apartment
                      </option>
                      <option value="StudioApartment">Studio Apartment</option>
                      <option value="custom">Custom</option>
                    </select>

                    <label>Select Building Type</label>
                  </div> */}
                </>
              )}

              {/* {data.buildingType === "custom" && (
                <div className="ce-field ce-float">
                  <select
                    name="customBuildingType"
                    value={data.customBuildingType}
                    onChange={handle}
                    required
                  >
                    <option value=""></option>
                    <option value="Residential">Residential</option>
                    <option value="Commercial">Commercial</option>
                    <option value="MixedUse">Mixed Use</option>
                    <option value="Hospital">Hospital</option>
                  </select>

                  <label>Select Custom Building Type</label>
                </div>
              )} */}

              {/* <div className="ce-btn-row">
                <button className="ce-btn ce-back" disabled>
                  Back
                </button>

                <button
                  className="ce-btn"
                  disabled={
                    !data.openPlot && !data.nonApprovedProperty
                      ? true
                      : data.openPlot
                        ? !data.areaInputType ||
                          (data.areaInputType === "lengthWidth" &&
                            (!data.openPlotLength || !data.openPlotWidth)) ||
                          (data.areaInputType === "area" && !data.openPlotArea)
                        : !data.society || !data.plot || !data.buildingType
                  }
                  onClick={nextStep}
                >
                  Next
                </button>
              </div> */}

<div className="ce-btn-row">

  {step !== 1 && (
    <button
      className="ce-btn ce-back"
      onClick={() => setStep(step - 1)}
    >
      Back
    </button>
  )}

  <button
    className="ce-btn"
    onClick={nextStep}
  >
    Next
  </button>

</div>

            </div>
          )}

          {/* STEP 2 */}

          {step === 2 && (
            <div className="ce-card">
              <h3>Plot Size</h3>

<div className={`ce-input-type-selector ${hasError("areaInputType") ? "ce-group-error" : ""}`}>

<label className="ce-input-type-radio">
<input
type="radio"
name="areaInputType"
value="lengthWidth"
checked={data.areaInputType === "lengthWidth"}
onChange={(e)=>{
setData({...data,areaInputType:e.target.value});
clearFieldError("areaInputType", "length", "width", "openPlotArea");
}}
/>
<span className="ce-radio-dot"></span>
I know Length and Width
</label>

<label className="ce-input-type-radio">
<input
type="radio"
name="areaInputType"
value="area"
checked={data.areaInputType === "area"}
onChange={(e)=>{
setData({...data,areaInputType:e.target.value});
clearFieldError("areaInputType", "length", "width", "openPlotArea");
}}
/>
<span className="ce-radio-dot"></span>
I know Total Area
</label>

</div>
             
{data.areaInputType === "lengthWidth" && (
<>

{/* Unit Dropdown */}

<div className={`ce-field ce-float ${hasError("unit") ? "ce-field-error" : ""}`}>
<select
name="unit"
value={data.unit}
onChange={handle}
required
>
<option value=""></option>
<option value="Feet">Feet</option>
<option value="Meters">Meters</option>
</select>

<label>Unit</label>
</div>


{/* Length Width Row */}

<div className="ce-input-row">

<div className={`ce-field ce-field-half ce-no-spinner ${hasError("length") ? "ce-field-error" : ""}`}>

<input
type="number"
name="length"
value={data.length}
onChange={handle}
placeholder=""
min="0"
step="0.01"
/>

<label>Length ({data.unit || "Feet"})</label>

</div>


<div className={`ce-field ce-field-half ce-no-spinner ${hasError("width") ? "ce-field-error" : ""}`}>

<input
type="number"
name="width"
value={data.width}
onChange={handle}
placeholder=""
min="0"
step="0.01"
/>

<label>Width ({data.unit || "Feet"})</label>

</div>

</div>

</>
)}

{data.areaInputType === "area" && (
<>

<div className="ce-field ce-float">

<select
name="openPlotAreaUnit"
value={data.openPlotAreaUnit}
onChange={handle}
required
>
<option value="sq.ft">sq.ft</option>
<option value="sq.meter">sq.meter</option>
</select>

<label>Unit</label>

</div>


<div className={`ce-field ce-no-spinner ${hasError("openPlotArea") ? "ce-field-error" : ""}`}>

<input
type="number"
name="openPlotArea"
value={data.openPlotArea}
onChange={handle}
placeholder=""
min="0"
step="0.01"
/>

<label>Total Area ({data.openPlotAreaUnit})</label>

</div>

</>
)}
              {/* Authority */}
              <div className={`ce-field ce-float ${hasError("authority") ? "ce-field-error" : ""}`}>
                <select
                  name="authority"
                  value={data.authority}
                  onChange={handle}
                  required
                >
                  <option value=""></option>
                  <option value="PMC">PMC</option>
                  <option value="PCMC">PCMC</option>
                  <option value="PMRDA">PMRDA</option>
                </select>

                <label>Select Authority</label>
              </div>

              {/* Road Width */}
              <div className={`ce-field ce-float ${hasError("road") ? "ce-field-error" : ""}`}>
                <select
                  name="road"
                  value={data.road}
                  onChange={handle}
                  required
                >
                  <option value=""></option>
                  <option value="6">6 Meter</option>
                  <option value="9">9 Meter</option>
                  <option value="12">12 Meter</option>
                  <option value="15">15 Meter</option>
                  <option value="24">24 Meter</option>
                  <option value="30">30 Meter</option>
                </select>
                <label>Select Road Width</label>
              </div>

              <div className="ce-result">
                <p>Total Area: {data.area}</p>
                <p>FSI: {data.fsi}</p>
                <p>Construction Area: {data.constructionArea}</p>
              </div>

              <div className="ce-btn-row">
                <button className="ce-btn ce-back" onClick={() => setStep(1)}>
                  Back
                </button>

                <button
                  className="ce-btn"
                  onClick={nextStep}
                >
                  Next
                </button>
              </div>
            </div>
          )}

          {/* STEP 3 */}

          {step === 3 && (
  <div className="ce-card">
    <h3>Select Consultancy Services</h3>
<p className="mb-3"  >Choose the consultancy services for your project to help us prepare a tailored quotation.</p>

    {/* ARCHITECTURE SERVICE */}

    <div
      // className={`ce-arch-toggle ${!data.architecture ? "active" : ""}`}
      className={`ce-arch-toggle ${data.architecture ? "active" : ""}`}
      onClick={() =>
        setData({ ...data, architecture: !data.architecture })
      }
    >
      <div className="ce-arch-head">
        <div className="ce-checkbox">{data.architecture && "✓"}</div>

        <div>

          <strong>
      Architecture Consultancy Service <span className="ce-required">*</span>
    </strong>

          <p>
            End-to-end architectural design from concept planning to
            construction drawings, including furniture layout planning
            with electrical and plumbing services.
          </p>
        </div>
      </div>
    </div>

    {!data.architecture && (
      <div className="ce-archBox">
        {/* <div className="ce-archHeader">
          <h5>Select Consultancy Services</h5>
          <p>
            Choose the consultancy services required for your project so we can
            prepare your quotation.
          </p>
        </div> */}

        <div className="ce-archRow">
          <strong>Architectural Design</strong>
          <span>
            Concept design, site planning, floor plans, elevations, sections,
            and façade design.
          </span>
        </div>

        <div className="ce-archRow">
          <strong>Interior Layout Planning</strong>
          <span>
            Functional space planning including kitchen, living, and room
            layouts.
          </span>
        </div>

        <div className="ce-archRow">
          <strong>Services Drawings</strong>
          <span>Electrical and plumbing layout coordination.</span>
        </div>

        <div className="ce-archRow">
          <strong>3D Visualizations</strong>
          <span>
            Realistic 3D views to help visualize the final design.
          </span>
        </div>

        <div className="ce-archRow">
          <strong>Construction Drawings</strong>
          <span>
            Detailed working drawings for accurate on-site execution.
          </span>
        </div>

        <div className="ce-archRow">
          <strong>Site Visits & Coordination</strong>
          <span>
            Site guidance and coordination with consultants during
            construction.
          </span>
        </div>
      </div>
    )}

    {/* LIAISONING SERVICE */}

   <div
  className={`ce-arch-toggle ${data.pmc ? "active" : ""}`}
  onClick={() => setData({ ...data, pmc: !data.pmc })}
>
      <div className="ce-arch-head">
        <div className="ce-checkbox">{data.pmc && "✓"}</div>

        <div>
          <strong>Liaisoning & Authority Approvals</strong>
          <p>
            Complete support for obtaining project permissions from municipal
            corporations and other local authorities.
          </p>
        </div>
      </div>
    </div>

    {!data.pmc && (
      <div className="ce-archBox">
        <div className="ce-archHeader">
          <h5>Services include:</h5>
        </div>

        <div className="ce-archRow">
          {/* <strong>Sanction drawings & documentation</strong> */}
          <p>Sanction drawings & documentation</p>
        </div>

        <div className="ce-archRow">
          {/* <strong>File submission and approval process</strong> */}
          <p>File submission and approval process</p>
        </div>

        <div className="ce-archRow">
          {/* <strong>Authority coordination & follow-ups</strong> */}
          <p>Authority coordination & follow-ups</p>
        </div>

        <div className="ce-archRow">
          {/* <strong>Support for Plinth Certificate approval</strong> */}
          <p>Support for Plinth Certificate approval</p>
        </div>

        <div className="ce-archRow">
          {/* <strong>
            Assistance and coordination until Completion Certificate
          </strong> */}
          <p>Assistance and coordination until Completion Certificate</p>
        </div>
      </div>
    )}

    {/* BUTTONS */}

    <div className="ce-btn-row">
      <button
        className="ce-btn ce-back"
        onClick={() => setStep(data.openPlot ? 1 : 2)}
      >
        Back
      </button>

      <button
        className="ce-btn"
        disabled={!data.architecture && data.pmc}
        onClick={nextStep}
      >
        Next
      </button>
    </div>
  </div>
)}

        {/* STEP 4 */}

{step === 4 && (
  <>
   
    <div className="ce-sticky-header">
      <h2 className="ce-title">
        Choose Project Services & Construction Options
      </h2>
      <p className="ce-subtitle">
        Please select the services and construction scope for your project.
      </p>
    </div>

  <div className="ce-card">


    
    {/* <h2 className="ce-title">Choose Project Services & Construction Options</h2>
    <p className="ce-subtitle">
      Please select the services and construction scope for your project.
    </p> */}

    {/* Liaison */}

    {data.pmc && (
      <>
    <h3 className="ce-section-title">1. Select Liaisoning Authority</h3>

    <div className={`ce-grid-options ${hasError("liaison") ? "ce-group-error" : ""}`}>

      <label className={`ce-option ${data.liaison === "PMRDA" ? "active" : ""}`}>
        <input
          type="radio"
          name="liaison"
          value="PMRDA"
          checked={data.liaison === "PMRDA"}
          onChange={handle}
        />
        <span className="ce-radio"></span>
        <div>
          <strong>PMRDA</strong>
          <p>Pune Metropolitan Region Development Authority</p>
        </div>
      </label>

      <label className={`ce-option ${data.liaison === "PCMC" ? "active" : ""}`}>
        <input
          type="radio"
          name="liaison"
          value="PCMC"
          checked={data.liaison === "PCMC"}
          onChange={handle}
        />
        <span className="ce-radio"></span>
        <div>
          <strong>PCMC</strong>
          <p>Pimpri Chinchwad Municipal Corporation</p>
        </div>
      </label>

      <label className={`ce-option ${data.liaison === "PMC" ? "active" : ""}`}>
        <input
          type="radio"
          name="liaison"
          value="PMC"
          checked={data.liaison === "PMC"}
          onChange={handle}
        />
        <span className="ce-radio"></span>
        <div>
          <strong>PMC</strong>
          <p>Pune Municipal Corporation</p>
        </div>
      </label>

      <label className={`ce-option ${data.liaison === "Other" ? "active" : ""}`}>
        <input
          type="radio"
          name="liaison"
          value="Other"
          checked={data.liaison === "Other"}
          onChange={handle}
        />
        <span className="ce-radio"></span>
        <div>
          <strong>Other</strong>
          <p>Other Local Authority</p>
        </div>
      </label>

    </div>
      </>
    )}

    {/* Construction */}

    <h3 className="ce-section-title">{data.pmc ? "2. Construction Services" : "1. Construction Services"}</h3>

    <div className={`ce-grid-options ${hasError("construction") ? "ce-group-error" : ""}`}>

      <label className={`ce-option ${data.construction === "grey" ? "active" : ""}`}>
        <input
          type="radio"
          name="construction"
          value="grey"
          checked={data.construction === "grey"}
          onChange={handle}
        />
        <span className="ce-radio"></span>
        <div>
          <strong>Grey Structure Only</strong>
          <p>Construction of the core building structure including RCC framework, brickwork, and plaster.</p>
        </div>
      </label>

      <label className={`ce-option ${data.construction === "complete" ? "active" : ""}`}>
        <input
          type="radio"
          name="construction"
          value="complete"
          checked={data.construction === "complete"}
          onChange={handle}
        />
        <span className="ce-radio"></span>
        <div>
          <strong>Complete Construction</strong>
          <p>
            End-to-end construction from structural work to final finishing, ready for occupancy.
          </p>
        </div>
      </label>

      <label className={`ce-option ${data.construction === "pmc" ? "active" : ""}`}>
        <input
          type="radio"
          name="construction"
          value="pmc"
          checked={data.construction === "pmc"}
          onChange={handle}
        />
        <span className="ce-radio"></span>
        <div>
          <strong>PMC (Project Management Consultancy)</strong>
          {/* <p>
            Project supervision, contractor coordination & quality control.
          </p> */}

<p>End-to-end construction support to manage your project smoothly from planning to final execution.</p>

        </div>


      </label>


 {/* PMC DETAILS (DEFAULT SHOW, PMC SELECT PAR HIDE) */}

    {!["pmc",].includes(data.construction) && (
      <div className="ce-archBox" style={{marginTop:"2px"}}>

        {/* <div className="ce-archHeader">
          <h5>Project Management Consultancy (PMC)</h5>
          <p>
            End-to-end construction support to manage your project smoothly from planning to final execution.
          </p>
        </div> */}

        <div className="ce-archRow">
          <p>Coordination between architect, structural consultants, and service consultants</p>
        </div>

        <div className="ce-archRow">
          <p>Contractor selection guidance and scope clarification</p>
        </div>

        <div className="ce-archRow">
          <p>Construction planning and scheduling</p>
        </div>

        <div className="ce-archRow">
          <p>Site supervision and quality checks</p>
        </div>

        <div className="ce-archRow">
          <p>Progress monitoring and issue resolution</p>
        </div>

        <div className="ce-archRow">
          <p>Ensuring work is executed as per approved drawings</p>
        </div>

        <div className="ce-archRow">
          <p>Support until project completion</p>
        </div>

      </div>
    )}
      
      <label className={`ce-option ${data.construction === "none" ? "active" : ""}`}>
        <input
          type="radio"
          name="construction"
          value="none"
          checked={data.construction === "none"}
          onChange={handle}
        />
        <span className="ce-radio"></span>
        <div>
          <strong>No Construction Services Required (Skip)</strong>
          <p>Client will manage construction independently; no construction support required.</p>
        </div>
      </label>

    </div>

    {/* Interior */}

    <h3 className="ce-section-title">3. Interior</h3>

    <div className={`ce-grid-options ${hasError("interior") ? "ce-group-error" : ""}`}>

      <label className={`ce-option ${data.interior === "kitchen" ? "active" : ""}`}>
        <input
          type="radio"
          name="interior"
          value="kitchen"
          checked={data.interior === "kitchen"}
          onChange={handle}
        />
        <span className="ce-radio"></span>
        <div>
          <strong>Modular Kitchen + POP Ceiling</strong>
          <p>Modern kitchen with smart storage and POP false ceiling.</p>
        </div>
      </label>

      <label className={`ce-option ${data.interior === "full" ? "active" : ""}`}>
        <input
          type="radio"
          name="interior"
          value="full"
          checked={data.interior === "full"}
          onChange={handle}
        />
        <span className="ce-radio"></span>
        <div>
          <strong>Full Interior Package</strong>
          <p>Kitchen, wardrobes, sofas, beds.</p>
        </div>
      </label>

      <label className={`ce-option ${data.interior === "none" ? "active" : ""}`}>
        <input
          type="radio"
          name="interior"
          value="none"
          checked={data.interior === "none"}
          onChange={handle}
        />
        <span className="ce-radio"></span>
        <div>
          <strong> No Interior Services Required (Skip)</strong>
          <p>Only construction without interior work.</p>
        </div>
      </label>

    </div>

    {/* Building */}

    {/* <h3 className="ce-section-title">4. Building Type</h3>

    <div className="ce-grid-options">

      <label className={`ce-option ${data.building === "p3" ? "active" : ""}`}>
        <input
          type="radio"
          name="building"
          value="p3"
          checked={data.building === "p3"}
          onChange={handle}
        />
        <span className="ce-radio"></span>
        <div>
          <strong>Parking + 3 Floors</strong>
        </div>
      </label>

      <label className={`ce-option ${data.building === "g2" ? "active" : ""}`}>
        <input
          type="radio"
          name="building"
          value="g2"
          checked={data.building === "g2"}
          onChange={handle}
        />
        <span className="ce-radio"></span>
        <div>
          <strong>Ground + 2 Floors</strong>
        </div>
      </label>

      <label className={`ce-option ${data.building === "custom" ? "active" : ""}`}>
        <input
          type="radio"
          name="building"
          value="custom"
          checked={data.building === "custom"}
          onChange={handle}
        />
        <span className="ce-radio"></span>
        <div>
          <strong>Custom Building</strong>
        </div>
      </label>

    </div> */}

    <div className="ce-btn-row">
      <button className="ce-btn ce-back" onClick={() => setStep(3)}>
        Back
      </button>

      {/* <button
        className="ce-btn"
        disabled={!data.building}
        onClick={nextStep}
      >
        Next
      </button> */}

      <button
        className="ce-btn"
        onClick={nextStep}
      >
  Next
</button>

    </div>

  </div>

  </>
)}

          {/* STEP 5 */}

{step === 5 && (
  <div className="ce-card">

    <h3 className="bt-section-title">Select the type of building</h3>

    {/* BUILDING TYPE */}
    <div className={`ce-field ce-float ${hasError("buildingType") ? "ce-field-error" : ""}`}>
      <select
        name="buildingType"
        value={data.buildingType}
        onChange={handle}
      >
        <option value=""></option>
        <option value="RowHouse">Row House</option>
        <option value="TwinBungalow">Twin Bungalow</option>
        <option value="IndependentBungalow">Independent Bungalow</option>
        <option value="ResidentialApartment">Residential Apartment</option>
        <option value="StudioApartment">Studio Apartment</option>
        <option value="Commercial">Commercial</option>
        <option value="MixedUse">Mixed Use</option>
      </select>
      <label>Select Building Type</label>
    </div>

    {/* STRUCTURE */}
    <div className={`bt-grid ${hasError("building") ? "bt-group-error" : ""}`}>
      {[
        { label: "Parking + 3 Floors", value: "p3" },
        { label: "Ground + 2 Floors", value: "g2" },
        { label: "Custom Building", value: "custom" }
      ].map((item) => (
        <label
          key={item.value}
          className={`bt-card ${data.building === item.value ? "active" : ""}`}
        >
          <input
            type="radio"
            name="building"
            value={item.value}
            checked={data.building === item.value}
            onChange={handle}
          />
          <span className="bt-radio"></span>
          <span>{item.label}</span>
        </label>
      ))}
    </div>

    {/* LAST FLOOR FUNCTION */}
    {(() => {

      const renderLastFloorOptions = (floorKey, label) => (
        <>
          <div className="ce-field ce-float">
            <select
              name={`${floorKey}Type`}
              value={data[`${floorKey}Type`] || ""}
              onChange={handle}
            >
              <option value=""></option>
              <option value="full">Full Floor</option>
              <option value="half">Half Terrace + Rooms</option>
              <option value="terrace">Only Terrace</option>
            </select>
            <label>{label} Type</label>
          </div>

          {data[`${floorKey}Type`] === "full" && (
            <div className="ce-field">
              <input
                type="text"
                name={`${floorKey}Full`}
                value={data[`${floorKey}Full`] || ""}
                onChange={handle}
                placeholder=" "
              />
              <label>{label} Requirement</label>
            </div>
          )}

          {data[`${floorKey}Type`] === "half" && (
            <div className="ce-field">
              <input
                type="text"
                name={`${floorKey}Rooms`}
                value={data[`${floorKey}Rooms`] || ""}
                onChange={handle}
                placeholder=" "
              />
              <label>{label} Requirement</label>
            </div>
          )}

          {data[`${floorKey}Type`] === "terrace" && (
            <div className="ce-field">
              <input
                type="text"
                name={`${floorKey}TerraceOnly`}
                value={data[`${floorKey}TerraceOnly`] || ""}
                onChange={handle}
                placeholder=" "
              />
              <label>Terrace Details</label>
            </div>
          )}
        </>
      );

      return (
        <>
          {data.building && (
            <>
              <h3>Floor Requirements</h3>

              {/* 🔸 P+3 */}
              {data.building === "p3" && (
                <>
                  <div className="ce-field">
                    <input
                      type="number"
                      name="cars"
                      value={data.cars}
                      onChange={handle}
                      placeholder=" "
                    />
                    <label>No. of Cars Parking</label>
                  </div>

                  <div className="ce-field">
                    <input
                      type="text"
                      name="floor1"
                      value={data.floor1}
                      onChange={handle}
                      placeholder=" "
                    />
                    <label>1st Floor</label>
                  </div>

                  <div className="ce-field">
                    <input
                      type="text"
                      name="floor2"
                      value={data.floor2}
                      onChange={handle}
                      placeholder=" "
                    />
                    <label>2nd Floor</label>
                  </div>

                  {renderLastFloorOptions("thirdFloor", "3rd Floor")}
                </>
              )}

              {/* 🔸 G+2 */}
              {data.building === "g2" && (
                <>
                  <div className="ce-field">
                    <input
                      type="text"
                      name="ground"
                      value={data.ground}
                      onChange={handle}
                      placeholder=" "
                    />
                    <label>Ground Floor</label>
                  </div>

                  <div className="ce-field">
                    <input
                      type="text"
                      name="floor1"
                      value={data.floor1}
                      onChange={handle}
                      placeholder=" "
                    />
                    <label>1st Floor</label>
                  </div>

                  {renderLastFloorOptions("secondFloor", "2nd Floor")}
                </>
              )}

              {/* 🔸 CUSTOM (FINAL UX) */}
              {data.building === "custom" && (
                <>
                  {/* PARKING */}
                  <div className="ce-field ce-float">
                    <select
                      name="customParking"
                      value={data.customParking || ""}
                      onChange={handle}
                    >
                      <option value=""></option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                    <label>Parking Required?</label>
                  </div>

                  {/* YES → CARS */}
                  {data.customParking === "yes" && (
                    <div className="ce-field">
                      <input
                        type="number"
                        name="cars"
                        value={data.cars}
                        onChange={handle}
                        placeholder=" "
                      />
                      <label>No. of Cars Parking</label>
                    </div>
                  )}

                  {/* NO → GROUND */}
                  {data.customParking === "no" && (
                    <div className="ce-field">
                      <input
                        type="text"
                        name="ground"
                        value={data.ground}
                        onChange={handle}
                        placeholder=" "
                      />
                      <label>Ground Floor Requirement</label>
                    </div>
                  )}

                  {/* FLOORS COUNT */}
                  <div className="ce-field">
                    <input
                      type="number"
                      value={data.floorsCount}
                      onChange={handleFloors}
                      placeholder=" "
                    />
                 <label>How many floors?</label>
                  </div>

                  {/* FLOORS LOOP */}
                  {data.floorsData.map((floor, index) => {
                    const isLast = index === data.floorsData.length - 1;

                    return (
                      <div key={index}>
                        {!isLast ? (
                          <div className="ce-field">
                            <input
                              type="text"
                              value={floor.value}
                              onChange={(e) =>
                                handleFloorInput(index, e.target.value)
                              }
                              placeholder=" "
                            />
                            <label>{getOrdinal(index + 1)} Floor</label>
                          </div>
                        ) : (
                          renderLastFloorOptions(
                            `floor${index + 1}`,
                            `${index + 1} Floor`
                          )
                        )}
                      </div>
                    );
                  })}
                </>
              )}
            </>
          )}
        </>
      );
    })()}

    {/* BUTTONS */}
    <div className="ce-btn-row">
      <button className="ce-btn ce-back" onClick={() => setStep(4)}>
        Back
      </button>

      <button
        className="ce-btn"
        onClick={nextStep}
      >
        Next
      </button>
    </div>

  </div>
)}

          {/* STEP 7 */}

        {step === 7 && (
  <div className="ce-card">
    <h3>Contact Info</h3>
    {errors.packageType && <span className="ce-error">{errors.packageType}</span>}

    {/* NAME */}
    <div className={`ce-field ${hasError("name") ? "ce-field-error" : ""}`}>
      <input
        type="text"
        name="name"
        value={data.name}
        onChange={(e) => {
  handle(e);
  clearFieldError("name");
}}
        placeholder=" "
      />
      <label>Name *</label>
      {errors.name && <span className="ce-error">{errors.name}</span>}
    </div>

    {/* MOBILE */}
    <div className={`ce-field ${hasError("mobile") ? "ce-field-error" : ""}`}>
      <input
        type="text"
        name="mobile"
        value={data.mobile}
        onChange={(e) => {
          const value = e.target.value.replace(/\D/g, "").slice(0, 10);

          setData({
            ...data,
            mobile: value,
          });

          clearFieldError("mobile", "email"); 
        }}
        placeholder=" "
      />
      <label>Mobile *</label>
      {errors.mobile && <span className="ce-error">{errors.mobile}</span>}
    </div>

    {/* EMAIL */}
    <div className={`ce-field ${hasError("email") ? "ce-field-error" : ""}`}>
      <input
        type="email"
        name="email"
        value={data.email}
        onChange={(e) => {
          handle(e);
          clearFieldError("email", "mobile"); 
        }}
        placeholder=" "
      />
      <label>Email *</label>
      {errors.email && <span className="ce-error">{errors.email}</span>}
    </div>

    {/* BUTTONS */}
    <div className="ce-btn-row">
      <button
        className="ce-btn ce-back"
        disabled={isSubmitting}
        onClick={() => setStep(getContactStepBackTarget(data.construction))}
      >
        Back
      </button>

      <button
        className="ce-btn ce-submit"
       disabled={isSubmitting}
        onClick={handleSubmit}
      >
        {isSubmitting ? (
          <span className="ce-btn-loading">
            <span className="ce-spinner ce-spinner-inline" aria-hidden="true"></span>
            Processing...
          </span>
        ) : (
          "Calculate My Cost"
        )}
      </button>
    </div>
  </div>
)}


        </div>

{step !== 6 && (
  
        <div className="ce-summary">
          
          <h3>Estimate Summary</h3>

          {/* Property Details */}

          <h4>Property Details</h4>

          <div className="ce-summary-row">
            <span>Society</span>
            <b>{data.society || "-"}</b>
          </div>

          <div className="ce-summary-row">
            <span>Plot</span>
            <b>{data.plot || "-"}</b>
          </div>

        
          {data.openPlot ? (
            <>
              <div className="ce-summary-row">
                <span>Property Type</span>
                <b>Open Plot</b>
              </div>

              {data.areaInputType === "lengthWidth" && (
                <>
                  <div className="ce-summary-row">
                    <span>Open Plot Length</span>
                    <b>{data.openPlotLength || "-"} {data.openPlotLengthWidthUnit}</b>
                  </div>

                  <div className="ce-summary-row">
                    <span>Open Plot Width</span>
                    <b>{data.openPlotWidth || "-"} {data.openPlotLengthWidthUnit}</b>
                  </div>
                </>
              )}

              {data.areaInputType === "area" && (
                <div className="ce-summary-row">
                  <span>Open Plot Area</span>
                  <b>{data.openPlotArea || "-"} {data.openPlotAreaUnit}</b>
                </div>
              )}

              <div className="ce-summary-row">
                <span>Non-Approved Property</span>
                <b>{data.nonApprovedProperty ? "Yes" : "No"}</b>
              </div>
            </>
          ) : (
            <>
              <div className="ce-summary-row">
                <span>Unit</span>
                <b>{data.unit}</b>
              </div>

              <div className="ce-summary-row">
                <span>Length</span>
                <b>{data.length || "-"}</b>
              </div>

              <div className="ce-summary-row">
                <span>Width</span>
                <b>{data.width || "-"}</b>
              </div>

              <div className="ce-summary-row">
                <span>Authority</span>
                <b>{data.authority || "-"}</b>
              </div>

              <div className="ce-summary-row">
                <span>Road Width</span>
                <b>{data.road}</b>
              </div>
            </>
          )}

          {!data.openPlot && (
            <>
              <div className="ce-summary-row highlight">
<span>Plot Area</span>
<b>
{data.areaInputType==="area"
? `${data.openPlotArea} ${data.openPlotAreaUnit}`
: `${data.area} sq.ft`}
</b>
</div>

              {/* Construction */}

              <h4>Construction</h4>

              <div className="ce-summary-row">
                <span>FSI</span>
                <b>{data.fsi}</b>
              </div>

              <div className="ce-summary-row highlight">
                <span>Construction Area</span>
                <b>{data.constructionArea}</b>
              </div>
            </>
          )}

          {/* Consultancy */}

          <h4>Consultancy</h4>

          <div className="ce-summary-row">
            <span>Architecture</span>
            <b>{data.architecture ? "Yes" : "No"}</b>
          </div>

          <div className="ce-summary-row">
            <span>Liaisoning & Authority Approvals</span>
            <b>{data.pmc ? "Yes" : "No"}</b>
          </div>

          {/* Services */}

          <h4>Services</h4>

          {data.pmc && (
            <div className="ce-summary-row">
              <span>Liaison</span>
              <b>{data.liaison || "-"}</b>
            </div>
          )}

          <div className="ce-summary-row">
            <span>Construction</span>
            <b>{getDisplayConstructionType(data)}</b>
          </div>

          <div className="ce-summary-row">
            <span>Interior</span>
            <b>{data.interior || "-"}</b>
          </div>

          {/* Building */}

       <h4>Building</h4>

{/* <div className="ce-summary-row">
  <span>Building Type</span>
  <b>{data.building || "-"}</b>
</div> */}

<div className="ce-summary-row">
  <span>Building Type</span>
  <b>{getDisplayBuildingType(data.buildingType)}</b>
</div>

          {data.buildingType === "custom" && (
            <div className="ce-summary-row">
              <span>Custom Building</span>
              <b>{data.customBuildingType || "-"}</b>
            </div>
          )}

<div className="ce-summary-row">
  <span>Building Structure</span>
  <b>
    {data.building === "p3" && "Parking + 3 Floors"}
    {data.building === "g2" && "Ground + 2 Floors"}
    {data.building === "custom" && "Custom Building"}
    {!data.building && "-"}
  </b>
</div>

{/*  P+3 */}
{data.building === "p3" && (
  <>
    <div className="ce-summary-row">
      <span>Parking</span>
      <b>{data.parking || "-"}</b>
    </div>

    <div className="ce-summary-row">
      <span>Floor 1</span>
      <b>{data.floor1 || "-"}</b>
    </div>

    <div className="ce-summary-row">
      <span>Floor 2</span>
      <b>{data.floor2 || "-"}</b>
    </div>

    <div className="ce-summary-row">
      <span>Floor 3</span>
      <b>
        {data.thirdFloorType === "full" && data.thirdFloorFull}
       {data.thirdFloorType === "half" &&
  data.thirdFloorRooms}
        {data.thirdFloorType === "terrace" && data.thirdFloorTerraceOnly}
        {!data.thirdFloorType && "-"}
      </b>
    </div>
  </>
)}

{/*  G+2 */}
{data.building === "g2" && (
  <>
    <div className="ce-summary-row">
      <span>Ground Floor</span>
      <b>{data.ground || "-"}</b>
    </div>

    <div className="ce-summary-row">
      <span>Floor 1</span>
      <b>{data.floor1 || "-"}</b>
    </div>

    <div className="ce-summary-row">
      <span>Floor 2</span>
      <b>
        {data.secondFloorType === "full" && data.secondFloorFull}
        {data.secondFloorType === "half" &&
  data.secondFloorRooms}
        {data.secondFloorType === "terrace" && data.secondFloorTerraceOnly}
        {!data.secondFloorType && "-"}
      </b>
    </div>
  </>
)}

{/*  Custom */}
{data.building === "custom" && (
  <>
    {data.floorsData.map((floor, index) => {
      const isLast = index === data.floorsData.length - 1;

      return (
        <div className="ce-summary-row" key={index}>
          <span>Floor {index + 1}</span>

          <b>
            {!isLast
              ? floor.value || "-"
              : (
                  <>
                    {data[`floor${index + 1}Type`] === "full" &&
                      data[`floor${index + 1}Full`]}
                   {data[`floor${index + 1}Type`] === "half" &&
  data[`floor${index + 1}Rooms`]}
                    {data[`floor${index + 1}Type`] === "terrace" &&
                      data[`floor${index + 1}TerraceOnly`]}
                    {!data[`floor${index + 1}Type`] && "-"}
                  </>
                )}
          </b>
        </div>
      );
    })}
  </>
)}
          {/* Other */}

          {/* <h4>Other</h4>

          <div className="ce-summary-row">
            <span>Other Details</span>
            <b>{data.other || "-"}</b>
          </div> */}

          {/* Contact */}

          <h4>Contact</h4>

          <div className="ce-summary-row">
            <span>Name</span>
            <b>{data.name || "-"}</b>
          </div>

          <div className="ce-summary-row">
            <span>Mobile</span>
            <b>{data.mobile || "-"}</b>
          </div>

          <div className="ce-summary-row">
            <span>Email</span>
            <b>{data.email || "-"}</b>
          </div>
        </div>
        )}

      </div>

      {/* SUMMARY MODAL - MOBILE VIEW ONLY */}
     {showSummary && (
  <div className="ce-summary-modal-overlay">
    <div className="ce-summary-modal">

      <div className="ce-summary-modal-header">
        <h2>Verify Your Details</h2>
        <p>Please review all the information before submitting</p>
      </div>

      <div className="ce-summary-modal-content">

        {/* PROPERTY */}
        <div className="ce-modal-section">
          <h4>Property Details</h4>

          <div className="ce-modal-row">
            <span>Society</span>
            <b>{data.society || "-"}</b>
          </div>

          <div className="ce-modal-row">
            <span>Plot</span>
            <b>{data.plot || "-"}</b>
          </div>

          <div className="ce-modal-row">
            <span>Building Type</span>
            <b>{getDisplayBuildingType(data.buildingType)}</b>
          </div>
        </div>

        {/* AREA */}
        <div className="ce-modal-section">
          <h4>Area Details</h4>

          <div className="ce-modal-row">
            <span>Plot Area</span>
            <b>{data.area || "-"} sq.ft</b>
          </div>

          <div className="ce-modal-row">
            <span>FSI</span>
            <b>{data.fsi || "-"}</b>
          </div>

          <div className="ce-modal-row">
            <span>Construction Area</span>
            <b>{data.constructionArea || "-"} sq.ft</b>
          </div>
        </div>

        {/* SERVICES */}
        <div className="ce-modal-section">
          <h4>Services</h4>

          <div className="ce-modal-row">
            <span>Architecture</span>
            <b>{data.architecture ? "Yes" : "No"}</b>
          </div>

          <div className="ce-modal-row">
            <span>Liaison</span>
            <b>{data.pmc ? data.liaison || "-" : "-"}</b>
          </div>

          <div className="ce-modal-row">
            <span>Construction</span>
            <b>{getDisplayConstructionType(data)}</b>
          </div>

          <div className="ce-modal-row">
            <span>Interior</span>
            <b>{data.interior || "-"}</b>
          </div>
        </div>

        {/* BUILDING */}
      {/* BUILDING */}
<div className="ce-modal-section">
  <h4>Building Details</h4>

  <div className="ce-modal-row">
    <span>Structure</span>
    <b>
      {data.building === "p3" && "Parking + 3 Floors"}
      {data.building === "g2" && "Ground + 2 Floors"}
      {data.building === "custom" && "Custom Building"}
      {!data.building && "-"}
    </b>
  </div>

  {/* P+3 */}
  {data.building === "p3" && (
    <>
      <div className="ce-modal-row">
        <span>Parking</span>
        <b>{data.parking || "-"}</b>
      </div>

      <div className="ce-modal-row">
        <span>1st Floor</span>
        <b>{data.floor1 || "-"}</b>
      </div>

      <div className="ce-modal-row">
        <span>2nd Floor</span>
        <b>{data.floor2 || "-"}</b>
      </div>

      <div className="ce-modal-row">
        <span>3rd Floor</span>
        <b>
          {data.thirdFloorType === "full" && data.thirdFloorFull}
          {data.thirdFloorType === "half" && data.thirdFloorRooms}
          {data.thirdFloorType === "terrace" && data.thirdFloorTerraceOnly}
          {!data.thirdFloorType && "-"}
        </b>
      </div>
    </>
  )}

  {/* G+2 */}
  {data.building === "g2" && (
    <>
      <div className="ce-modal-row">
        <span>Ground Floor</span>
        <b>{data.ground || "-"}</b>
      </div>

      <div className="ce-modal-row">
        <span>1st Floor</span>
        <b>{data.floor1 || "-"}</b>
      </div>

      <div className="ce-modal-row">
        <span>2nd Floor</span>
        <b>
          {data.secondFloorType === "full" && data.secondFloorFull}
          {data.secondFloorType === "half" && data.secondFloorRooms}
          {data.secondFloorType === "terrace" && data.secondFloorTerraceOnly}
          {!data.secondFloorType && "-"}
        </b>
      </div>
    </>
  )}

  {/* CUSTOM */}
  {data.building === "custom" &&
    data.floorsData.map((floor, index) => {
      const isLast = index === data.floorsData.length - 1;

      return (
        <div className="ce-modal-row" key={index}>
          <span>{getOrdinal(index + 1)} Floor</span>
          <b>
            {!isLast
              ? floor.value || "-"
              : (
                  <>
                    {data[`floor${index + 1}Type`] === "full" &&
                      data[`floor${index + 1}Full`]}

                    {data[`floor${index + 1}Type`] === "half" &&
                      data[`floor${index + 1}Rooms`]}

                    {data[`floor${index + 1}Type`] === "terrace" &&
                      data[`floor${index + 1}TerraceOnly`]}

                    {!data[`floor${index + 1}Type`] && "-"}
                  </>
                )}
          </b>
        </div>
      );
    })}
</div>

        {/* OTHER */}
        {/* <div className="ce-modal-section">
          <h4>Other</h4>
          <div className="ce-modal-row">
            <span>Details</span>
            <b>{data.other || "-"}</b>
          </div>
        </div> */}

        {/* CONTACT */}
        <div className="ce-modal-section">
          <h4>Contact</h4>

          <div className="ce-modal-row">
            <span>Name</span>
            <b>{data.name || "-"}</b>
          </div>

          <div className="ce-modal-row">
            <span>Mobile</span>
            <b>{data.mobile || "-"}</b>
          </div>

          <div className="ce-modal-row">
            <span>Email</span>
            <b>{data.email || "-"}</b>
          </div>
        </div>

      </div>

      {/* FOOTER */}
      <div className="ce-summary-modal-footer">
        <button
          className="ce-btn ce-edit-btn"
          disabled={isSubmitting}
          onClick={() => setShowSummary(false)}
        >
          Edit Details
        </button>

        <button className="ce-btn ce-confirm-btn" disabled={isSubmitting} onClick={submit}>
          {isSubmitting ? (
            <span className="ce-btn-loading">
              <span className="ce-spinner ce-spinner-inline" aria-hidden="true"></span>
              Processing...
            </span>
          ) : (
            "Submit"
          )}
        </button>
      </div>
    </div>
  </div>
)}

    {isSubmitting && (
      <div className="ce-processing-overlay" role="status" aria-live="polite" aria-busy="true">
        <div className="ce-processing-card">
          <span className="ce-spinner" aria-hidden="true"></span>
          <h3>Preparing Your PDF</h3>
          <p>{getSubmitStatusMessage(submitStatus)}</p>
          <span className="ce-processing-note">
            Please stay on this page. Your WhatsApp PDF share option will appear shortly.
          </span>
        </div>
      </div>
    )}

    </div>

    </>
  );
}
